export default {
	es: {
		guardar: "Guardar",
		volver: "< Volver",
		sin_definir: "Sin definir",
		guardar_datos: "Guardar datos",
		cancelar: "Cancelar",
		confirmar: "Confirmar",
		eliminar: "Eliminar",
		aceptar: "Aceptar",
		rechazar: "Rechazar",
		comenzar: "Comenzar",
		cerrar_sesion: "Cerrar sesión",
		ver_menos: "Ver menos",
		ver_mas: "Ver más",
		inicio: "Inicio",
		ver_detalles: "Ver detalles",
		guardar: "Guardar",
		editar: "Editar",
		anadir: "Añadir",
		enviar: "Enviar",
		requerido: "Requerido",
		revisar: "Revisar",
		editar_oferta: "Editar oferta",
		duplicar_oferta: "Duplicar oferta",
		cerrar_oferta: "Cerrar oferta",
		eliminar_oferta: "Elimina oferta",
		ver_como_candidato: "Ver como candidato",
		practicas: "Prácticas",
		empleo: "Empleo",
		ver: "Ver",
		selecciona_una_opcion: "Selecciona una opción",
		dropzone_texto_upload_mobile: "Haz click para adjuntar el archivo",
		dropzone_texto_upload_desktop: "Arrastra o selecciona el archivo para subir el documento",
		escribe_para_filtrar: "Escribe para filtrar",
		no_hay_resultados: "No hay resultados",
		alert_error_generico: "ERROR",
		alert_proximamente: "Muy pronto disponible",
		alert_redireccion_recuperar: "Redirección a sistemas de universidad/centro para que el usuario recupere su contraseña",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/login",
			solicitar_cuenta: "/solicitar-cuenta",
			registroalumno: "/registro",
			encuestas: '/encuestas',
			encuesta: '/encuesta',
			eventos: '/eventos',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertas-practicas',
			ofertas_empleo: '/ofertas-empleo',
			cv: '/cv',
			vercv: '/ver-cv',
			mis_candidaturas: '/mis-candidaturas',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/subir-convenio-firmado',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nueva-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/mi-empresa',
			mi_perfil: '/mi-perfil',
			mis_ofertas: '/mis-ofertas',
			mi_oferta: '/oferta',
			programa_practicas: '/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablecer-login',
			restablecer_candidato: '/restablecer-candidato',
			setear_pass: '/establecer-login',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acceso',
			logout: '/cerrar-sesion',
			ayuda: '/ayuda',
			condicionespracticasuib: '/uib/condiciones-practicas',
			formulario_datos: '/formulario-datos',
		},
		encabezado: {
			home: 'Bienvenid@',
			cv: 'Mi currículum',
			cv_view: 'Currículum del candidato',
			eventos: 'Eventos',
			propuesta_practicas: "Propuesta de prácticas",
			politica_privacidad: "Política de privacidad",
			politica_cookies: "Política de cookies",
			login: "Inicio de sesión",
			solicitar_cuenta: "Nueva empresa",
			registro_alumno: "Registro",
			ofertas_practicas: 'Listado de ofertas de prácticas',
			ofertas_empleo: 'Listado de ofertas de empleo',
			ficha_oferta_alumno_empleo: 'Listado de ofertas de empleo',
			ficha_oferta_alumno_practicas: 'Listado de ofertas de prácticas',
			mis_candidaturas: 'Mis candidaturas',
			mis_practicas: 'Mis prácticas',
			encuestas: 'Encuestas',
			orientacion: 'Orientación laboral',
			nueva_oferta: 'Nueva oferta',
			editar_oferta: 'Editar oferta',
			mi_empresa: "Mi empresa",
			mi_perfil: "Mi perfil",
			documentacion: 'Documentación',
			guiasOrientacion: 'Guías Orientación',
			documentacion_empresa: 'Documentación',
			documentacion_alumno: 'Mi documentación',
			mis_ofertas: 'Mis ofertas',
			mi_oferta: 'Mi oferta',
			ficha_oferta_empresa: 'Mi oferta',
			restablecer_login: 'Restablecer Contraseña',
			restablecer_candidato: 'Restablecer Contraseña',
			programapracticasactivos: 'Programas de prácticas activos',
			setear_pass: 'Establecer Contraseña',
			proteccion_datos: 'Protección de datos',
			visor_oferta: "Ver como alumno",
			fichaProgramaActivo: "Programas activos",
			solicitudCambioPracticas: "Solicitud cambio de prácticas",
			solicitudesEducacion: "Solicitudes ofertas educación",
			subirConvenioFirmado: 'Subir convenio firmado',
			generarNuevoConvenio: 'Nuevo convenio de Colaboración',
			ayuda: 'Ayuda',
			condicionespracticasuib: "Condiciones prácticas",
			info_alumno: "Recuerda que si quieres realizar prácticas hasta el 31 de agosto no solicites el título hasta pasada dicha fecha. En el caso de solicitar el título antes del 31 de agosto perderás la condición de alumno y ya no podrás realizar prácticas.",
			formulario_datos: 'Formulario datos',
			formulario_incorporacion: 'Formulario de incorporación',
			falta_num_ss: 'Debido a la entrada en vigor del nuevo RD el real decreto-ley 2/2023, de 16 de marzo que entrará en vigor el 1 de enero 2024 es OBLIGATORIO nos facilites tu número de la Seguridad Social y adjuntes una copia del mismo. Accede a tu perfil para cumplimentar esta información:'
		},
		ficha_oferta: {
			texto_programa_anadido: "Tienes este programa añadido a tu lista de programas informáticos"
		},
		formulario: {
			nombre: "Nombre",
			nombre_apellidos: "Nombre y apellidos",
			apellidos: "Apellidos",
			email: "Email",
			mensaje: "Mensaje",
			fecha_nacimiento: "Fecha de nacimiento",
			dia: "Día",
			mes: "Mes",
			anyo: "Año",
			area_interes: "Área de su interés",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Si",
			no: "No",
			carta_presentacion: "Carta de presentacion",
			meses: {
				Enero: "Enero",
				Febrero: "Febrero",
				Marzo: "Marzo",
				Abril: "Abril",
				Mayo: "Mayo",
				Junio: "Junio",
				Julio: "Julio",
				Agosto: "Agosto",
				Septiembre: "Septiembre",
				Octubre: "Octubre",
				Noviembre: "Noviembre",
				Diciembre: "Diciembre"
			},
			archivo_adjunto: "Adjuntar archivo",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduce tu email",
			pais: "País",
			telefono: "Teléfono",
			he_leido: "He leído y acepto la",
			y_acepto: "política de privacidad",
			enviar: "Enviar",
			enviado: "Enviado",
		},
		meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		login: {
			iniciar_sesion: 'Iniciar sesión',
			acceder: 'Acceder',
			email: "Email",
			error_mail: "Por favor, indica tu email para logarte en el portal.",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			contrasena_olvidada: "He olvidado mi contraseña",
			introduce_email: 'Introduce tu email',
			email_mal: 'El email está mal formado',
			recuperar_pass: 'Recuperar mi contraseña',
			aun_no_registrado: "¿Aún no estas registrado/a?",
			acceder_SSO: "ACCEDER SSO UNIVERSIDAD",
			indica_mail: "Por favor, indica tu <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
			selecciona_empresa: "Por favor, selecciona la empresa con la que quieres logarte.",
			titulacion: "Titulación",
			tipo_formacion: "Tipo de formación academica",
			selecciona_formacion: "Selecciona un tipo de formación",
			registrarme: "Registrarme",
			deseo_recibir: "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB.",
			popup_rgpd: {
				titulo: 'INFORMACIÓN AMPLIADA',
				detalle: 'Si necesitas ampliar información más detallada, puedes acceder a la Política de Protección de Datos en ',
				enlace: 'este enlace.',
				boton: 'Consiento, acceder'
			},
			restablecer_pass: {
				titulo: 'Sigue los pasos para restablecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un número.',
				guardar: 'Guardar'
			},
			seteo_pass: {
				titulo: 'Sigue los pasos para establecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un número.',
				guardar: 'Guardar'
			},

		},
		registro: {
			encabezado: 'Cumplimenta el formulario a continuación para darte de alta en el sistema:',
			datos_usuario: "Datos del usuario de empresa",
			datos_personales: "Datos personales",
			nombre: "Nombre",
			apellidos: "Apellidos",
			DNI: "DNI/NIF/NIE",
			CIF: "CIF de la empresa",
			puesto: "Puesto / Cargo",
			departamento: "Departamento",
			telefono_1: "Teléfono 1",
			telefono_2: "Teléfono 2",
			email: "Email",
			sede: "Sede por defecto",
			cargo: "Cargo",
			idioma: "Idioma de preferencia",
			tipo_contacto: "Tipo de Contacto",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			direccion: "Dirección",
			pais: "País",
			selecciona_pais: "-selecciona un país-",
			selecciona_idioma: "-Selecciona un idioma-",
			provincia: "Provincia",
			selecciona_provincia: "-Selecciona una provincia-",
			localidad: "Localidad",
			selecciona_localidad: "-Selecciona una localidad-",
			direccion: "Dirección",
			direccion_empresa: "Dirección Empresa",
			cp: "Código Postal",
			titulo_2: "A continuación introduce los datos de tu empresa para darte de alta en el sistema:",
			anadir_imagen: "Haz click para añadir la imagen",
			autorizar_logo: "Autorizar uso del logo",
			nombre_fiscal: "Nombre fiscal o Razón social",
			nombre_comercial: "Nombre comercial",
			tipo_sociedad: 'Tipo de Sociedad',
			selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
			tipo_empresa: "Tipo de Empresa",
			privada: "Privada",
			publica: "Pública",
			startup: "Startup",
			eliminar: "Eliminar",
			descripcion: "Descripción",
			si: "Sí",
			no: "No",
			sector: "Sector",
			selecciona_sector: "-Selecciona un sector-",
			otro_sector: "Otro Sector",
			numero_empleados: "Número de empleados",
			selecciona_empleados: "-Selecciona un rango-",
			web: "Web",
			iban: "Número cuenta IBAN",
			descripcion_empresa: "Descripción de la empresa",
			'femenino': 'Femenino',
			'masculino': 'Masculino',
			telefono: "Teléfono",
			firmante: {
				titulo: "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
				nombre: "Nombre del firmante",
				apellidos: "Apellidos del firmante",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Cargo del firmante",
				telefono: "Teléfono"
			},
			contacto: {
				nombre: "Nombre del contacto",
				apellidos: "Apellidos del contacto",
				email: "Email del contacto",
				telefono: "Teléfono"
			},
			envio_facturas: {
				titulo: "Dirección envío de facturas",
				titulo_2: "Dirección de facturación"
			},
			anadir_direccion: "Añadir nueva dirección de facturación",
			perfil_sectorial: "Perfil sectorial",
			sector_actividad: "Sector de actividad",
			selecciona_sector_actividad: "-Selecciona un sector-",
			rango: "Rango de facturación",
			selecciona_rango: "-Selecciona un rango-",
			numero_empleados: "Número de empleados",
			selecciona_numero_empleados: "-Selecciona un rango-",
			anyo_fundacion: "Año de fundación",
			politica_1: "He leído y acepto la ",
			politica_2: "política de privacidad",
			nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
			anadir_contacto: "Añadir contacto",
			nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
			domicilio_fiscal: "Domicilio Fiscal",
			poblacion: "Población",
			requiere_envio_postal: "Requiere envío postal facturas",
			domicilio_postal: "Domicilio para el envio postal de facturas",
			anadir_cuenta: "Añadir cuenta",
			datos_firmante: "Datos del firmante",
			area_conocimiento: "Área o rama de conocimiento",
			centro_lugar_estudios: "Centro o lugar de estudios",
			busca_centro_lugar: "Busca el centro o el lugar",
			nombre_titulacion: "Nombre de la titulación",
			ano_inicio: "Año de inicio",
			ano_finalizacion: "Año de finalización",
			solicitar_cuenta: "Solicitar cuenta",
			seguir_empresa: "Seguir con los datos de la empresa",
			registrar_empresa: "Registrar Empresa",
			selecciona_sede: "-Elige una-",
			fiscal_empresa: "Fiscal Empresa",
			rgpd: {
				titulo: "Protección de datos",
				responsable_tratamiento: "Responsable del tratamiento",
				responsable_texto: "FUNDACION GENERAL DE LA UNIVERSIDAD DE VALLADOLID (informacion@funge.uva.es). Delegado de Protección de Datos: dpo@funge.uva.es",
				finalidad_principal: "Finalidad principal",
				finalidad_texto: "Las actividades de empleo y orientación laboral de la FUNGE desarrolla acciones que tienen como objetivo facilitar la inserción laboral de los estudiantes y titulados universitarios, para lo cual trata datos de carácter personal.",
				legitimacion: "Legitimación",
				legitimacion_texto: "Relación contractual. Consentimiento del interesado. Interés público.",
				categorias_datos_personales: "Categorías de datos personales",
				categorias_texto: "Datos identificativos. Datos académicos y profesionales.",
				destinatarios: "Destinatarios",
				destinatario_1: "Empresas acogidas a los programas de prácticas.",
				destinatario_2: "Universidad de Valladolid",
				destinatario_3: "Entidades responsables de la selección, por cuenta de las empresas acogidas a los programas de prácticas.",
				derechos: "Derechos",
				derechos_texto: "Acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.",
				informacion_adicional: "Información adicional",
				informacion_adicional_texto_1: "Puede consultar más información en el",
				informacion_adicional_texto_2: "y en nuestra",
				registro_actividades: "Registro de actividades de tratamiento",
				politica_privacidad: "política de privacidad"
			},
			dni_pasaporte_nie: "DNI/NIF/NIE/Pasaporte",
			selecciona_nivel: "-Selecciona un nivel-",
			busca_area: 'Busca el área',
			busca_titulacion: 'Busca la titulación',
			firmaDigital: "Tipo de firma para convenio",
			asume_coste_SS: "¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social de los alumnos que realicen prácticas formativas o prácticas académicas externas en su institución tal y como recoge en el Real Decreto-ley 2/2023?",
			asume_coste_SS_Si: "Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
			asume_coste_SS_No: "No Aceptamos. Solicitamos que sea la Universidad Pontificia Comillas, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023."
		},
		idiomas:{
			es: "Español",
			en: "Inglés"
		},
		propuesta_practicas: {
			intro: "Si has encontrado una empresa en la que realizar tus prácticas académicas curriculares o extracurriculares, puedes darla de alta aquí. La valoraremos y asignaremos si cumple con todos los requisitos exigidos.",
			documento_resumen: "Documento resumen de toma de datos para hacer la propuesta de prácticas en este formulario.",
			descargar: "Descargar",
			info_desconocido: "Si desconoces algún dato por favor indícanos \"desconocido\".",
			info_master: "Si eres estudiante de Máster en Profesorado de Educación Secundaria Obligatoria, Bachillerato, FP y Enseñanza de Idiomas puedes solicitar centro educativo para realizar tus prácticas, tanto si ya tienes plaza confirmada como si no.",
			datos_academicos: "Datos académicos",
			paso_1_4: "Paso 1 de 4",
			selecciona_titulacion: "Selecciona una titulación",
			placeholder_titulacion: "Haz clic para seleccionar una titulación",
			curso: "Curso",
			tipo_practica: "¿Qué tipo de práctica vas a solicitar/proponer?",
			curricular: "Curricular",
			extracurricular: "Extracurricular",
			solicitud_educacion: "¿Vas a realizar tu solicitud para las prácticas de una titulación de Educación y Profesorado?",
			plaza_confirmada: "¿Tienes ya plaza confirmada en algún centro?",
			plaza_si: "Sí, tengo una plaza confirmada en un centro educativo",
			plaza_no: "No, deseo proponer un centro de mi interés para la realización de prácticas.",
			atencion: "¡Atención!",
			atencion_texto: "Solamente en el caso de no tener confirmada tu plaza para la realización de prácticas en un centro educativo.",
			solicitudes_restantes: "Cuentas con",
			solicitudes_centros_restantes: "solicitudes de centros restantes.",
			certificado_centro_docente: "Certificado de centro docente",
			vida_laboral: "Vida laboral",
			datos_empresa: "Datos de la empresa",
			paso_2_4: "Paso 2 de 4",
			introduce_cif: "Introduce el CIF de la empresa, donde vas a realizar las practicas.",
			cif_nif: "CIF (empresa) o NIF (autónomo)",
			validar_empresa: "Validar empresa",
			selecciona_centro: "Selecciona el Centro de realización de las prácticas. Búscalo por provincia y nombre:",
			selecciona_centro_educativo: "Selecciona el Centro educativo:",
			centro_educativo: "Centro educativo",
			cargando: "Cargando...",
			no_hay_empresas: "No hay empresas",
			no_encuentro_empresa: "No encuentro la empresa",
			cif_empresa: "CIF de la empresa",
			datos_centro_trabajo: "Datos del centro de trabajo",
			codigo_postal: "Código postal",
			dni_firmante: "DNI del firmante",
			datos_contacto_empresa: "Datos del contacto de la empresa",
			paso_3_4: "Paso 3 de 4",
			introduce_email_contacto: "Introduce el email de tu contacto en la empresa.",
			validar_contacto: "Validar contacto",
			puesto_cargo: "Puesto / Cargo",
			revisa_campos: "Por favor revisa todos los campos para poder continuar",
			aviso_confirmacion_universidad: "¡Atención! Tienes que esperar la confirmación de la universidad para dar por validadas tus prácticas. Tu solicitud entrará a trámite y recibirás la resolución a través de la mensajería del campus.",
			comprueba_datos_empresa: "Comprueba que los datos de la empresa coinciden con los datos de la empresa donde vas a realizar las prácticas. En caso tener una duda, o haber algun error escríbenos a",
			nombre_empresa: "Nombre de la empresa",
			cif_no_existe: "El CIF proporcionado no existe en nuestra base de datos, por favor rellena los siguientes campos.",
			nombre_comercial: "Nombre comercial",
			nombre_fiscal: "Nombre fiscal",
			email_empresa: "Email de empresa",
			datos_representante_legal: "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
			nombre_firmante: "Nombre del firmante",
			apellidos_firmante: "Apellidos del firmante",
			email_firmante: "Email del firmante",
			telefono_firmante: "Teléfono del firmante",
			cargo_firmante: "Cargo del firmante",
			comprueba_datos_contacto: "Comprueba que los datos de la empresa coinciden con los datos del contacto. En caso tener una duda, o haber algun error escríbenos a",
			nombre_contacto: "Nombre del contacto",
			email_contacto: "Email del contacto",
			contacto_no_existe: "No tenemos datos en nuestra base de datos de tu contacto, por favor rellena los datos.",
			datos_firmante: "Datos del firmante",
			info_facturacion: "Información adicional para facturación"
		},
		propuesta_practicas_empresa: {
			intro: "Si un alumno/a va a realizar prácticas en su empresa, puede dar de alta aquí todos los detalles. Valoraremos y formalizaremos su propuesta si, tanto las prácticas ofertadas como el candidato/a seleccionado/a, cumplen con los requisitos exigidos.",
			datos_alumno: "Datos del alumno/a",
			instrucciones: "Puede consultar las instrucciones de propuesta de prácticas",
			selecciona_programa: "Selecciona un programa de prácticas",
			introduce_dni: "Introduce el DNI de candidato/a.",
			validar_candidato: "Validar candidato/a",
			titulacion_candidato: "Titulación del candidato/a",
			placeholder_titulacion_alumno: "Introduce la titulación del alumno",
			comprueba_datos_candidato: "Comprueba que los datos del candidato/a coinciden. Si tienes dudas, o hay algún error escríbenos a",
			nombre_candidato: "Nombre del candidato/a"
		},
		programa_activo: {
			programa: "Programa",
			duracion_practicas: "Duración de las prácticas",
			minima: "mínima",
			brutos_mes: "brutos/mes",
			tiempo_dedicacion: "Tiempo de dedicación a la práctica",
			de: "de",
			jornada_laboral: "la jornada laboral",
			nivel_estudios_permitidos: "Nivel de estudios permitidos",
			y: "y",
			informacion_general: "Información general",
			objetivo: "Objetivo",
			requisitos: "Requisitos",
			requisitos_candidatos: "Requisitos para candidatos",
			requisitos_empresas: "Requisitos para empresas",
			documentacion_necesaria: "Documentación necesaria",
			documentacion_interes: "Documentación de interés",
			solicitud_adhesion_el: "Solicitud adhesión el",
			empresa_ya_adherida: "Su empresa ya está adherida a este programa",
			puede_adherirse_texto: "Puede adherirse al programa dando de alta la oferta de prácticas vinculada a este programa. Posteriormente la oferta será revisada y validada por el equipo de gestión.",
			solicitar_adhesion: "Solicitar Adhesión",
			adherirme_programa: "Adherirme al programa",
			solicitud_inscripcion: "de la solicitud inscripción",
			proceso_seleccion: "Proceso de selección",
			fecha_solicitud_inscripcion: "Fecha solicitud inscripción",
			nota: "Nota",
			inscribete: "Inscríbete",
			acepto: "Acepto"
		},
		home_empresa: {
			ofertas_practicas: "OFERTAS<strong>De prácticas</strong>",
			texto_ofertas_practicas: "Consulta y gestiona las ofertas de prácticas y las candidaturas recibidas.",
			nueva_practicas: "PUBLICAR<strong>Nueva oferta de prácticas",
			publicar_practicas: "Publica ofertas de prácticas, dirigidas a nuestros estudiantes.",
			nueva_propuesta: "SOLICITAR PRÁCTICA<strong>Propuesta de prácticas",
			publicar_propuesta: "Si no quieres dirigir una oferta a todos nuestros alumnos sino que ya conoces al estudiante que va a realizar la práctica. Haz tu propuesta de prácticas para el estudiante aquí.",
			ofertas_empleo: "OFERTAS<strong>De empleo",
			texto_ofertas_empleo: "Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.",
			nueva_empleo: "PUBLICAR<strong>Nueva oferta de empleo",
			texto_nueva_empleo: "Publica ofertas de empleo."
		},
		mi_practica: {
			subir_documentacion: "Subir documentación",
			descargar_anexo: "Descargar Anexo Firmado",
			descargar_certificado: "Descargar certificado de realización de prácticas",
			descargar_poliza: "Descargar póliza del seguro",
			info_poliza: "Información de tu póliza de seguro",
			titulo_practicas: "Para poder incorporarte a la realización de estas prácticas es necesario:",
			pagar_creditos: "Pagar los créditos que se van a reconocer.",
			descarga: "Descarga",
			aqui: "aquí",
			documento_pago: "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
			contratar_poliza: "Contratar una póliza de accidentes que te cubra estas prácticas",
			puedes_contratar: "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
			mensaje_documentos: "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
			digitaliza_documentos: "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
			adjuntar_pago: "Adjuntar resguardo de pago",
			adjuntar_seguro: "Adjuntar póliza de seguro",
			descarga_ficheros: "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
			enviar: "Enviar",
			renuncia_practicas_SET: "Estas prácticas extracurriculares formarán parte de tu SET (Suplemento Europeo al Título) si cumples los requisitos exigidos legalmente, en caso de que no desees que se unan a SET, debes adjuntar documento de renuncia firmado. Puedes descargar la plantilla del documento",
			adjuntar_renuncia: "Adjuntar renuncia firmada"
		},
		mis_practicas: {
			titulo: "En esta sección encontrarás toda la documentación referente a tus prácticas.",
			zero_1: "No hay ninguna práctica o documentación de prácticas para mostrar. En caso de duda, por favor contacta con:",
			gracias: "Muchas gracias.",
			emailJuridica: "practicas.derecho@comillas.edu",
			emailIngenieria: "practicas.ingenieria@comillas.edu",
			emailEconomica: "practicas.ade.ibs@comillas.edu",
			emailSanitaria: "practicas.soci.sani@comillas.edu",
			emailEducacion: "mvtorres@comillas.edu",
			emailRRII: "practicas.ri.com.ti@comillas.edu",
			emailInternacional: "jrmunoz@comillas.edu",
		},
		cambio_password: {
			titulo: "Cambiar contraseña",
			titulo_candidato: "¿Deseas cambiar tu contraseña?",
			contrasena_actual: "Contraseña actual",
			nueva_contrasena: "Nueva Contraseña",
			repetir_contrasena: "Repetir nueva Contraseña"
		},
		guia_orientacion: {
			titulo: "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
			zero: "No hay guias de orientación"
		},
		mi_empresa: {
			intro: {
				cuerpo: 'Se muestran a continuación los datos principales de su empresa. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.',
				porfavor: 'Si tiene cualquier duda, por favor, ',
				contacte: 'contacte con nosotros.'
			},
			datos_empresa: "Datos de la empresa",
		},
		formulario_datos: {
			intro: {
				cuerpo: 'Se muestran a continuación los datos principales de su empresa. Actualice o rellene la siguiente información sobre su empresa.',
				porfavor: 'Por favor, ',
				contacte: 'contacte con nosotros.'
			},
			datos_empresa: "Datos de la empresa",
			datos_firmante: "Datos del firmante",
			datos_contacto: "Datos del contacto"
		},
		candidaturas_options: {
			aceptar: "Aceptar inscripción",
			rechazar: "Rechazar inscripción",
			motivos_rechazo: "Motivos del rechazo",
			selecciona_motivo: "- Selecciona un motivo de rechazo -",
			rechazar_preinscripcion: "Rechazar preinscripción",
		},
		oferta: {
			intro_editor: "Cumplimenta el formulario a continuación para crear una oferta nueva:",
			tipo_oferta: "Tipo de oferta",
			numero_plazas: "Número de plazas",
			experiencia: "Experiencia",
			experiencia_deseable: "Experiencia deseable",
			horario: "Horario",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de finalización",
			tipo_contrato: "Tipo de contrato",
			salario: "Salario",
			creditos: "Créditos superados",
			otras_remuneraciones: "Otras remuneraciones",
			pais: "País",
			poblacion: "Población/Provincia",
			poblacion_only: "Población",
			provincia: "Provincia",
			sector: "Sector",
			area_funcional: "Área funcional",
			sede: "Sede/campus",
			beca: "Beca mensual",
			descripcion_puesto: "Descripción del puesto",
			tarea: "Tarea",
			tutores_disponibles: "Tutores disponibles",
			otras_tareas: "Otras tareas",
			programa_practicas: "Programa de prácticas",
			aviso_programa: "Importante consultar para comprobar requisitos obligatorios",
			aviso_requisitos_programa: "No olvides revisar los requisitos de este programa para las ofertas de prácticas. Puedes consultar todos los detalles",
			aqui: "aquí",
			escribe_para_buscar: "Escribe para buscar",
			ocultar: "Ocultar",
			selecciona_tutor: "Selecciona un tutor",
			enlace_inscripcion: "Enlace de inscripción",
			ir_enlace: 'Ir al enlace',
			idiomas: "Idiomas",
			anadir_idiomas: "Añadir Idiomas",
			empleo: "Empleo",
			practicas: "Prácticas",
			certificacion: "- Certificación mínima requerida:",
			requerido: "- Requerido",
			estudios_obligatorios: "Estudios obligatorios",
			estudios_deseables: "Estudios deseables",
			estudios_propuestos: "Estudios propuestos",
			requisitos_obligatorios: "Requisitos obligatorios",
			etiquetas: "Etiquetas",
			otros_obligatorios: "Otros obligatorios",
			edad_maxima: "Edad maxima",
			salario_maximo: "Salario Máximo",
			intereses_deseables: "Intereses deseables",
			intereses_obligatorios: "Intereses obligatorios",
			intereses_seleccionados: "Intereses seleccionados",
			competencias_obligatorias: "Competencias obligatorias",
			competencias_seleccionadas: "Competencias seleccionadas",
			paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
			paises_residencia_obligatorios: "Paises de Residencia obligatorios",
			provincia_residencia_obligatorios: "Provincia de Residencia obligatorios",
			paises_seleccionados: "Paises seleccionados",
			provincias_seleccionados: "Provincias seleccionadas",
			coche_propio: "Coche propio",
			obligatorio_quest: "¿Obligatorio?",
			carnet_conducir: "Carnet de conducir",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			disponible_residencia: "Disponible para cambio de residencia",
			trabajando_actualmente: "Trabajando actualmente",
			requisitos_deseables: "Requisitos deseables",
			otros_requisitos_deseables: "Otros Requisitos deseables",
			otros_requisitos_obligatorios: "Otros requisitos obligatorios",
			motivos_exclusion: "Motivos de exclusión",
			competencias_deseables: "Competencias deseables",
			paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
			paises_residencia_deseables: "Paises de Residencia deseables",
			provincia_residencia_deseables: "Provincia de Residencia deseables",
			programas_informaticos: "Programas informáticos",
			programas_informaticos_deseables: "Programas informáticos deseables",
			documentos_requeridos: "Documentos requeridos",
			documentos: "Documentos",
			marca_documentos: "Marca los documentos que deben aportar los candidatos/as.",
			anadir_otro_documento: "Añadir otro tipo de documento",
			nombre_documento_candidato: "Nombre del documento a aportar por el candidato",
			inscribirme: "Inscribirme",
			desinscribirme: "Desinscribirme",
			ya_inscrito: "ya estas inscrito",
			cancelar_inscripcion: "Cancelar inscripción",
			buscar_mas_intereses: "Busca más intereses",
			atencion: "¡Atención!",
			tramitar_inscripcion: "Para tramitar tu inscripción en esta oferta debes presentar tu candidatura en la web de la empresa ofertante.",
			acceder: "Para acceder",
			pincha_aqui: "pincha aquí.",
			especialidad: "Especialidad",
			estado: "Estado",
			datos_practica: "Datos de la práctica",
			paso_4: "Paso 4 de 4",
			tareas_a_desarrollar: "Tareas a desarrollar",
			horario: "Horario",
			horario_practicas: "Horario de prácticas",
			horario_trabajo: "Horario de trabajo",
			tengo_candidato: "Tengo candidato/a",
			horas_dia: "Horas al día",
			remuneracion: "Remuneración(€ brutos/mes)",
			otros_beneficios: "Otros beneficios",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			fecha_alta: "Fecha Alta",
			duracion_meses: "Duración (en meses)",
			dedicacion: "Dedicación (% jornada)",
			departamento: "Departamento",
			modalidad: "Modalidad",
			numero_dias_semana: "Numero de días por semana",
			dias_semana: "Días de la semana",
			vinculado_tfg: "Vinculado a TFG",
			nombre_tfg: "Nombre TFG",
			tutor_tfg: "Tutor/a TFG",
			solicitante: "Solicitante del servicio",
			centro_practicas: "Centro de prácticas",
			n_pedido: "Nº de pedido (si lo requiere)",
			observaciones: "Observaciones",
			direccion: "Dirección",
			nombre_tutor_uni: "Nombre y apellidos del tutor de la Universidad",
			datos_tutor_empresa: "Datos del tutor en la empresa",
			nombre: "Nombre",
			apellidos: "Apellidos",
			email: "Email",
			telefono: "Teléfono",
			cargo: "Cargo",
			dni: "DNI",
			titulacion_especialidad: "Titulación o especialidad",
			titulacion: "Titulación/ Cargo",
			selecciona: "-Seleccionar-",
			nombre_oferta: "Nombre de la oferta",
			numero_plazas: "Número de plazas",
			experiencia_requerida: "Experiencia requerida",
			experiencia_deseable: "Experiencia deseable",
			opciones_publicacion: "Opciones de publicación",
			url_inscripcion: "URL inscripción empresa",
			candidato_preferido: "Candidato/a preferido",
			datos_realizacion: "Datos de realización de la práctica",
			conocimientos_especificos: "Conocimientos especificos",
			formacion_adquirida: "Formación adquirida",
			seguimiento_previsto: "Seguimiento previsto",
			empresa_destino: "Empresa destino (solamente si es oferta de gestora/consultora ETT)",
			datos_tutor: "Datos del tutor/a de la empresa",
			para_estudiantes_ultimo_ano: "Para estudiantes de último año",
			curso_minimo_requerido: "Curso mínimo requerido",
			para_perfil_no_universitario: "Para perfil no universitario",
			activo_quest: "¿Activo?",
			ano_promo_maximo: "Año de promoción máximo",
			enviar_quest: "¿Enviar?",
			candidato_leer: "Candidato/a por leer",
			candidatos_leer: "Candidatos/as por leer",
			candidato_total: "Candidato/a en total",
			referencia: "Referència",
			candidatos_total: "Candidatos/as en total",
			ver_detalles: "Ver detalles",
			con_practicas: "- Con prácticas asignadas",
			fecha_caducidad: "Fecha de caducidad",
			buscar_mas_programa: "Busca más programas informáticos",
			programas_elegidos: "Programas informáticos elegidos",
			sin_programas: "Sin programas informáticos especificados",
			selecciona_idioma: "Selecciona un idioma",
			escribe_idioma: "Escribe aquí el idioma",
			indica_certificacion: "Indica aquí la certificación o nivel mínimo requerido",
			titulaciones: "Titulaciones",
			requeridas: "requeridas",
			deseables: "valorables",
			propuestas: "propuestas",
			a_las_que: "a las que se dirige la oferta",
			nivel: "Nivel",
			areas: "Áreas",
			cualquier_area: "Cualquier área",
			ninguna_titulacion: "Ninguna titulación concuerda con el filtro de nivel indicado.",
			eliminar_todas: "Eliminar todas",
			areas_dirige: "Áreas a las que se dirige la oferta",
			titulaciones_dirige: "Titulaciones a las que se dirige la oferta",
			selecciona_titulaciones: "Selecciona las titulaciones en el listado de la izquierda",
			cumplimentar: "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
			tipo_estudios: "Tipo de estudios",
			seleccione_izquierda: "Selecciona las áreas en el listado de la izquierda.",
			seleccione_algun_nivel: "Seleccione algún nivel para cargar las áreas asociadas",
			especialidad_titulacion: "Especialidad o titulación/es",
			puesto_trabajo: 'Puesto de trabajo',
			motivo_rechazo: "Motivo de rechazo",
			ayuda_estudio: "Ayuda al estudio",
			tutor_empresa: "Tutor de la empresa",
			nombre_tutor: "Nombre del tutor empresa",
			apellidos_tutor: "Apellidos del tutor empresa",
			email_tutor: "Email del tutor empresa",
			telefono_tutor: "Teléfono del tutor empresa",
			cargo_tutor: "Cargo del tutor empresa",
			titulacion_tutor: "Titulación del tutor empresa",
			departamento_tutor: "Departamento del tutor empresa",
			dni_tutor: "DNI del tutor empresa",
			no_definido: "No definido",
			candidatos: "Candidatos/as",
			exportar: "Exportar",
			no_hay_candidatos: "No hay candidatos/as en esta oferta",
			mas: "más",
			menos: "menos",
			empresa_destino_simple: "Empresa Destino",
			tipo_formacion: "Tipo de formación",
			niveles: "Niveles",
			areas: "Áreas",
			para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
			duplicar_oferta_aviso: "Oferta duplicada correctamente ¿Quieres editarla ahora?",
			alumno_validado_uib: "Alumno validado por DOIP UIB",
			condicionespracticas: "He leído y estoy de acuerdo con las condiciones. <a target='_blank' href='/uib/condiciones-practicas'>Ver condiciones</a>",
			idioma: "Idioma",
			ofertacerrada: "Una oferta cerrada no estará visible ni recibirá nuevos candidatos. ¿Estás seguro de querer cerrar esta oferta?",
			eliminaroferta: "Se va a eliminar la oferta ¿Quieres continuar?",
			ofertaduplicada: "Oferta duplicada correctamente ¿Quieres editarla ahora?",
			controlCerraroferta: "¿Ha seleccionado a alguno de los candidatos propuestos por DOIP UIB?",
			cumplimentainformacion: "Por favor cumplimente la siguiente información:",
			nombrepersona: "Nombre y apellidos de la persona seleccionada",
			fechainiciocontrato: "Fecha de inicio del contrato",
			tipocontrato: "Tipo de contrato",
			nota_media: "Nota media",
			observaciones: "Observaciones",
			nombre_apellidos_dni: "Nombre, apellidos y DNI",
			ocultar_datos_empresa: 'Ocultar datos de la empresa',
			url_informacion_complementaria: 'URL para información complementaria',
			fichero_informacion_complementaria: 'Fichero información complementaria:',
			seleccionar_archivo: 'Seleccionar archivo',
			ningun_archivo: 'No se ha seleccionado ningún archivo',
			ver_fichero_adjunto: 'Ver fichero adjunto:',
			ver_fichero: 'Ver fichero',
			datos_firmante: "Datos del firmante",
			selecciona_una:"Seleccione una",
			firmante: {
				nombre: "Nombre del firmante",
				apellidos: "Apellidos del firmante",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Cargo del firmante",
				telefono: "Teléfono"
			},
		},
		filtro_oferta: {
			buscar_nombre: "Busca por nombre del puesto",
			buscar_localizacion: "Busca por localización",
			buscar_titulacion: "Busca por titulación",
			buscar_puesto: "Busca por nombre del puesto",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			fecha_publicacion: "Fecha publicación",
			fecha_inicio_previsa: "Fecha de inicio de práctica prevista",
			fecha_inicio: "Fecha de inicio",
			filtrado_etiqueta: "Filtrado por etiquetas",
			omitir_inscritos: "Omitir ya inscritos",
			becas_colaboracion: "Becas de colaboración",
			oferta_tfg: "Oferta TFG/TFM",
			ofertas_internacional: "Oferta internacional",
			ofertas_cv: "Ofertas que encajan con mi perfil/cv",
			busquedas_guardadas: "Búsquedas guardadas",
			guardar_busqueda: "Guardar búsqueda",
			borrar_filtros: "BORRAR FILTROS",
			descargar_candidatos: "Descargar todos los candidatos",
			ver: "Ver",
			fecha: "Fecha",
			ofertas_tfg: "Oferta TFG/TFM",
			se_han_encontrado: "Se han encontrado",
			introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
			sobreescribe_existente: "ó sobreescribe una existente",
			selecciona_busqueda: "Selecciona una búsqueda",
			ver_historico: "Ver histórico de ofertas",
			ver_actuales: "Ver ofertas actuales",
			crear_oferta: "CREAR OFERTA",
			historico_ofertas: "Histórico de ofertas",
			no_hay_ofertas: "No hay ofertas coincidentes con tu búsqueda",
			solo_con_candidatos: "Sólo ofertas con candidatos/as sin leer",
			tienen_candidatos: "Tienen candidatos/as",
			caduca_pronto: "Caducan pronto",
			no_leidos: "Solo no leidos",
			modalidad: "Modalidad",
			puesto_Empresa: "Puesto/ Empresa",
			buscar_sector: "Buscar por sector",
			estados: { "1": "Pendiente", "2": "Publicada", "3": "Gestionada", "4": "Cerrada empresa", "5": "Cerrada adjudicada", "6": "Cerrada sin adjudicar", "7": "No publicable", "8": "Reserva" },
			idPerfil: { "1": "Empleo", "2": "Prácticas" }
		},
		popup_confirmacion: {
			recuerda: "¡Recuerda!",
			titulo: "Asegúrate de que los datos de tu perfil están actualizados antes de inscribirte a una oferta.",
			actualiza: "Actualízalo pinchando",
			aqui: "aquí.",
			confirma_titulo: "Por favor confirma que quieres ser candidato/a en esta oferta.",
			atencion: "¡Atención!",
			necesitamos_anadir: "Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.",
			url_documento: "URL del documento",
			por_favor_adjunta: "Por favor, adjunta un archivo o url",
			alumnos_master: "Los alumnos de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres alumno de máster de duración inferior a 2 años, o has superado el 50% de los créditos?",
			inscripcion_externa: "La inscripción de esta oferta se realiza a través de la web de la empresa.",
			confirma_inscripcion_externa: "Por favor, confirma que quieres ser redirigido a la web de la empresa para inscribirte a la oferta.",
		},
		header: {
			hola: "Hola, ",
			oferta_practicas: "Buscar ofertas de prácticas",
			oferta_empleo: "Buscar ofertas de empleo",
			propuesta_practicas: "Propuesta de prácticas",
			candidaturas: "Mis candidaturas",
			practicas: "Mis prácticas",
			programas: "Programas",
			encuestas: "Encuestas",
			eventos: "Eventos",
			mi_cv: "Mi CV",
			guias_orientacion: "Guías Orientación",
			mis_ofertas: "Mis ofertas",
			nueva_oferta: "Nueva oferta",
			solicitar_cambio_practicas: "Solicitar cambio de prácticas",
			documentacion: "Documentación",
			solicitudes_practicas_educacion: "Solicitudes prácticas educación",
			encuestas: "Encuestas",
			mi_empresa: "Mi empresa",
			ayuda: "Ayuda",
			cerrar_sesion: "Cerrar sesión",
			solicitar_baja: "Solicitar baja",
			formulario_datos: 'Formulario datos',
			asesoramiento: 'Solicita Asesoramiento'
		},
		image_uploader: {
			titulo: "Editar imagen de perfil"
		},
		notificaciones: {
			borrar_todo: "Borrar todo",
			importantes: "Importantes",
			otras_notificaciones: "Otras notificaciones",
			no_notificaciones: "No tienes notificaciones pendientes"
		},
		popup_borrar_cuenta: {
			titulo: "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
			si: "Sí",
			no: "No"
		},
		popup_faltan_datos_empresa: {
			atencion: "¡Atención!",
			cuerpo_1: "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
			cuerpo_2: "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
			ir_a_perfil: "Ir a mi Perfil",
			ir_a_empresa: "Ir a Mi empresa"
		},
		popup_datos_personales: {
			atencion: "¡Atención!",
			titulo: "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
			ir_a_perfil: "Ir a mi Perfil"
		},
		solicitudes_educacion: {
			titulo: "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
			zero: "No hay documentación en estos momentos."
		},
		filtro_candidaturas: {
			buscar_nombre: "Busca por nombre del puesto",
			empleo: "Empleo",
			practicas: "Prácticas",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			estado: "Estado",
			ver: "Ver",
			borrar_filtros: "BORRAR FILTROS",
			estas_en: "Estas en",
			zero: "No hay procesos de selección coincidentes con tu búsqueda"
		},
		documentacion: {
			adjunto: "Adjunto",
			intro: "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
			convenio_titulo: "Convenios de cooperación educativa",
			caducado: "(Caducado) -",
			zero_convenio: "Aún no tienes ningún convenio",
			titulo_convenio: "Si lo deseas puedes solicitar y descargar el convenio de colaboración, o aportar el documento ya firmado por tu empresa:",
			nuevo_convenio: "Nuevo convenio",
			subir_convenio: "Subir convenio firmado",
			anexos_practicas: "Anexos de prácticas",
			zero_practicas: "Aún no tienes contenido",
			notas_formativas: "Notas formativas",
			en: "en",
			otros_documentos: "Otros documentos asociados a prácticas",
			zero_documentos: "Aún no tienes ningún documento de prácticas",
			otros_documentos_programas: "Otros documentos asociados a programas",
			zero_documentos_practicas: "Aún no tienes ningún documento asociado a programas",
			documentos_aportados_empresa: "Otros documentos aportados por la empresa",
			no_documentos_anadidos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
			adendas: "Adendas/otros documentos:",
			activo: "Activo",
			caducado: "Caducado",
			subir_convenio_intro: "Adjunte aquí el archivo de Convenio de Colaboración Educativa firmado por su empresa para la tramitación de la firma.",
			convenios_pendientes: "Convenios pendientes",
			selecciona_convenio: "Selecciona el convenio",
			no_convenios_para_subir: "Aún no tienes convenios generados a los que puedas adjuntar el archivo firmado.",
			subir_convenio_boton: "Subir convenio"
			,
			tooltip_nuevo_convenio: "Solicita la generación de un nuevo convenio de colaboración.",
			tooltip_subir_convenio: "Para enviar convenios ya generados y firmados por tu empresa."
		},
		encuestas: {
			titulo: "Encuestas",
			obligatorias: "Para continuar, responde todas las preguntas obligatorias",
			enviar: "Enviar",
			siguiente: "Siguiente",
			empezar_de_nuevo: 'Empezar de nuevo',
			pagina: "Página",
			datos_enviados: "Tus datos han sido enviados",
			muchas_gracias: "¡Muchas gracias!",
			iniciar_sesion: "Inicia sesión con tu usuario de perfil",
			empresa: "Empresa",
			candidato: "Candidato",
			usuario: "Usuario",
			contrasena: "Contraseña",
			acceder: "Acceder",
			o: 'ó',
			acceder_anonimamente: "Acceder anonimamente",
			contestar_pregunta: "Debes contestar a esta pregunta para continuar",
			zero: "No hay encuestas disponibles",
			titulo: "Encuestas Pendientes",
			cuerpo: "Por favor, antes de continuar, responda estas encuestas",
			no_puedes: "No puedes acceder al portal hasta que no hayas contestado las encuestas pendientes. Si no deseas responder en este momento, puedes cerrar tu sesión.",
		},
		eventos: {
			proximos: "Próximos eventos",
			pasados: "Eventos pasados",
			evento_destacado: "Evento destacado",
			desde: "Desde",
			hasta: "Hasta",
			organizado_por: "Organizado por",
			inscribirse: "Inscribirse",
			inscrito: "Inscrito",
			mas_informacion: "Más información",
			galeria: "Galería de imágenes",
			videos: "Vídeos",
			buscar_localizacion: "Buscar por localización",
			buscar_categoria: "Buscar por categoría",
			buscar_nombre: "Buscar por nombre",
			eventos_pasados: "Eventos ya pasados",
			ver_mas: "Ver más"
		},
		comunicaciones: {
			titulo: "Comunicaciones"
		},
		guias: {
			titulo: "Últimas guías de orientación",
			zero: "No hay guias de orientación"
		},
		ofertas: {
			ultimas_practicas: "Últimas Ofertas de prácticas",
			practicas: "Prácticas",
			ultimas_empleo: "Últimas Ofertas de empleo",
			empleo: "Empleo",
			ofertas: "Ofertas",
			zero_ofertas: "No hay ofertas disponibles.",
			contrato: "Contrato",
			idContrato: "Contrato",
			salario: "Salario",
			areaFuncional: "Área Funcional",
			provincia: "Provincia",
			areasTitulaciones: "Áreas de titulaciones",
			nivelesTitulaciones: "Niveles de titulaciones",
			tiposFormacion: "Tipos de formación",
			tituloPrograma: "Programa",
			area: "Área",
			filtrar_titulacion: "Filtrar por titulación",
			tipoModalidadAsistencia: "Modalidad de asistencia"
		},
		cv: {
			nivel: "Nivel",
			programa_informatico: "Programa informático",
			certificado: "Certificado",
			sin_nivel: "Sin nivel definido",
			presentacion: "Presentación",
			anadir_presentacion: "Para añadir tu presenctación pulsa",
			aqui: "aquí",
			otros_intereses: "Otros intereses",
			tus_interes: "Tus intereses",
			sin_intereses: "Sin intereses especificados",
			escribe_interes: "Escribe algún interes, para comenzar a buscar",
			click_interes: "Haz click sobre el interes, para añadirlo",
			click_cambiar_imagen: "Haz click para cambiar la imagen",
			cambiar_contrasena: "Cambiar contraseña",
			idiomas: "Idiomas",
			idioma: "Idioma",
			sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
			idioma_obligatorio: "El idioma y el nivel son campos obligatorios para añadir un idioma",
			nivel_no_definido: "Nivel no definido",
			nivel: "Nivel",
			nombre_certificado: "Nombre del certificado",
			estancia_extranjero: "Estancia en el extranjero",
			pais_estancia: "País de estancia",
			motivo_estancia: "Motivo de la estancia",
			duracion_meses: "Duración en meses",
			experiencia_profesional: "Experiencia profesional",
			anadir_nueva_experiencia: "Añadir nueva experiencia",
			sin_experiencia: "Sin experiencia",
			nivel_formativo: "Nivel formativo",
			actualidad: "Actualidad",
			puesto: 'Titulo del puesto',
			anadir_documento: "Añadir documento",
			sector_empresa: "Sector de la empresa",
			area_actividad_puesto: "Área de actividad del puesto",
			tipo_contrato: "Tipo de contrato",
			subtipo_contrato: "Subtipo de contrato",
			ver_adjunto: "Ver adjunto",
			ver_enlace: "Ver enlace",
			duracion: "Duración",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			provincia: "Provincia",
			empresa: "Empresa",
			enlace: "Enlace",
			descripcion_puesto: "Descripción del puesto",
			escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
			anadir_fichero: "Añadir fichero adjunto",
			adjunto_correctamente: "Archivo adjunto correctamente",
			isla: "Isla",
			programas_informaticos: {
				titulo: "Programas informáticos",
				buscar: "Escribe para buscar",
				zero: "No hay programas informáticos añadidos, pulsa en añadir para añadirlos",
				anadir: "Añadir Programa",
			},
			sectores_interes: {
				titulo: "Sectores de interés",
				buscar: "Escribe para buscar",
				zero: "No hay sectores de interés añadidos, pulsa en añadir para añadirlos",
				anadir: "Añadir sector de interés",
			},
			documentacion_adjunta: "Documentación adjunta",
			documentacion_subida: "Documentación subida el",
			no_hay_documentos: "No hay documentos añadidos",
			pulsa_anadir_documentos: ", pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
			documentacion_privada: "Documentación privada",
			no_documentos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			documentacion_ligada: "Documentación ligada a procesos",
			datos_profesionales: "Datos profesionales",
			visitar: "Visitar",
			indica_link_perfil: "Indica link a tu perfil",
			trabajando_actualmente: "Trabajando actualmente",
			permiso_trabajo: "Permiso de trabajo en la UE",
			anos_experiencia: "Años de experiencia",
			sin_experiencia: "Sin experiencia",
			disfrutado_erasmus: "He estado de Erasmus o he disfrutado de otra beca de movilidad",
			minima_retribucion: "Mínima retribución",
			brutos_anuales: "/ brutos anuales",
			datos_personales: "Datos personales",
			dni: "DNI",
			fecha_nacimiento: "Fecha de nacimiento",
			genero: "Género",
			femenino: "Femenino",
			masculino: "Masculino",
			email_personal: "Email personal",
			email_estudiante: "Email de estudiante",
			avisos_en_email: "Avisos en el email personal",
			acepta_newsletter: "Acepta newsletter",
			idioma_comunicaciones: "Idioma preferido para las comunicaciones",
			movil: "Móvil",
			fijo: "Teléfono fijo",
			direccion_empadronamiento: "Dirección de empadronamiento",
			direccion_actual: "Dirección actual",
			direccion: "Dirección",
			iban: "Nº cuenta IBAN",
			seguridad_social: "Nº Seguridad social",
			pais_nacionalidad: "País de nacionalidad",
			pais_segunda_nacionalidad: "País de segunda nacionalidad",
			provincia_nacimiento: "Provincia de nacimiento",
			provincia: "Provincia",
			lugar_nacimiento: "Lugar de nacimiento",
			discapacidad: "Discapacidad superior al 33%",
			deseo_recibir_comunicaciones: "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB:",
			nombre: "Nombre",
			primer_apellido: "Primer apellido",
			segundo_apellido: "Segundo apellido",
			tipo_identificacion: "Tipo de identificación",
			documento_identidad: "Documento de identidad",
			buscar: "Escribe para buscar",
			cp: "Código Postal",
			pais: "País",
			localidad: "Localidad",
			tipo_via: "Tipo de vía",
			numero: "Número",
			piso: "Piso",
			puerta: "Puerta",
			notas: "Notas",
			datos_academicos: "Datos académicos",
			formacion_complementaria: "Formación complementaria",
			anadir_titulacion: "Añadir nueva titulación",
			complementaria: "complementaria",
			centro: "Centro",
			nivel_academico: "Nivel académico",
			tipo: "Tipo",
			nota: "Nota",
			rama_ensenanza: "Rama de la enseñanza",
			duracion: "Duración",
			actual: "Actual",
			si: "Sí",
			no: "No",
			titulo: "Titulo",
			universidad: "Universidad/Lugar de estudios",
			calificacion: "Calificación",
			calificacion_media: "Calificación media del titulo",
			horas: "Horas",
			ambito: "Ambito de la enseñanza",
			selecciona_tipo: "- Selecciona un tipo -",
			certificacion: "Certificación",
			tienes_cerfificacion: "¿Tienes certificación?",
			competencias_profesionales: "Competencias profesionales",
			tus_competencias: "Tus competencias",
			sin_competencias: "Sin competencias profesionales especificadas",
			solicitar_sesion: "¿Necesitas ayuda para cumplimentar este apartado? Puedes solicitar una sesión gratuita de orientación con nosotros pinchando en este <a href='https://content.fueib.org/es/orientacion?hsCtaTracking=b23fd2f4-3b24-4c45-9d90-9fd88b353e09%7Cd6de5ac5-da0e-420e-a24c-dc6ecd1b9dba' target='_blank'>enlace</a> y te ayudaremos.",
			datos_interes: "Datos de interés",
			busqueda_activa_practicas: "Búsqueda activa de prácticas",
			busqueda_activa_empleo: "Búsqueda activa de empleo",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			permiso_conducir: "Permiso de conducir",
			disponible_cambio_residencia: "Disponible para cambio de residencia",
			coche_propio: "Coche propio",
			disponible_viajar: "Disponible para viajar",
			discapacidad_certificada: "Discapacidad certificada",
			carnet_moto: "Carnet de moto",
			moto_propia: "Moto propia",
			disponibilidad_jornadas: "Disponilidad de jornadas",
			periodo_preferencia_practicas: "Periodo preferencia de prácticas",
			selecciona: "Selecciona",
			anadir_idioma: "Añadir idioma",
			anadir_intereses: "Añadir intereses",
			nuevos_datos_academicos: "Nuevos datos académicos",
			ocultar_de_mi_perfil: "Ocultar de mi perfil",
			centro_estudios_placeholder: "Centro en el que cursaste los estudios",
			duracion_horas: "Duración en horas",
		},
		addtitulacion: {
			titulo: "Titulaciones a las que se dirige la oferta",
			seleccione_areas: "Seleccione área/s para filtrar titulaciones",
			borrar_areas: "Borrar todas las áreas",
			cualquier_area: "Cualquier área",
			escriba_aqui: "Escriba aquí para filtrar el listado de titulaciones a continuación",
			selecciona_titulacion: "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
			ver_titulaciones: "Ver titulaciones de grado",
			listadas: "listadas",
			listados: "listados",
			cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
			ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
			cualquier_titulacion_postgrado: "Cualquiera de estas titulaciones de postgrado",
			ver_titulaciones_propio: "Ver titulaciones de Título propio",
			cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
			lo_sentimos: "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
			listado_titulaciones_seleccionadas: "Listado de titulaciones seleccionadas",
			eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas"
		},
		candidato: {
			nuevo: "Nuevo",
			cambiar_estado: "Cambiar estado",
			ver_cv: "Ver CV",
			detalles: "Detalles del candidato/a",
			selecciona_estado: "Selecciona un estado",
			seleccione_motivo: "Por favor seleccione el motivo de rechazo del candidato/a.",
			cambio_estado: "Cambio de estado",
			descargar_cv: "Descargar CV",
			cumplimentar_formulario_incorporacion: "Cumplimentar Formulario de Incorporación",
			expediente: "Expediente",
			info_formulario_practicas: "Por favor cumplimente el formulario a continuación con los datos correspondientes a las prácticas que realizará este candidato/a en su empresa.",
			dotacion_mensual: "Dotación mensual",
			descripcion_contenido_formativo: "Descripción contenido formativo",
			informacion_adicional_facturacion: "Información adicional para facturación"
		},
		cambio_practicas: {
			identifica: "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
			alumno: "Alumno",
			selecciona_oferta: "Selecciona la oferta",
			no_practicas: "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
			alumno: "Alumno/a",
			selecciona_alumno: "Selecciona el alumno/a",
			detalles: "Detalles de la modificación",
			tipo_modificacion: "Tipo de modificación",
			selecciona_modificacion: "-Selecciona la modificación-",
			otros_detalles: "Otros detalles",
			adjunto: "Adjunto",
			solicitar_cambio: "Solicitar cambio"
		},
		popup_idioma: {
			titulo: "Vas a cambiar tu preferencia de idioma. ¿Quieres continuar?",
		},
		formulario_incorporacion: {
			formularioYaCumplimentado: "Este formulario de incorporación ya ha sido cumplimentado y el alumno ha sido seleccionado.",
			encabezado: "Rellena el formulario de incorporación para completar la candidatura del alumno y pasarla a seleccionado.",

			persona_de_contacto: "Persona de contacto",
			contacto_nombre: "Nombre",
			contacto_apellidos: "Apellidos",
			contacto_cargo_departamento: "Cargo/Departamento",
			contacto_email: "E-mail",
			contacto_num_telefono: "Nº de Teléfono",

			persona_firmante_anexo_convenio: "Persona firmante del Anexo",
			persona_firmante_convenio_empresa: "Persona firmante del convenio empresa",
			firmante_nombre: "Nombre",
			firmante_apellidos: "Apellidos",
			firmante_cargo_departamento: "Cargo del firmante",
			firmante_email: "E-mail",
			firmante_telefono: "Teléfono",

			datos_alumno: "Datos del Alumno",
			alumno_dni: "DNI",
			alumno_nombre_apellidos: "Nombre y apellidos",
			alumno_titulacion: "Titulación",

			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",

			datos_periodo_practicas: "Datos sobre el Periodo de Prácticas",

			lugar_realizacion_practicas: "Lugar de realización de las prácticas",

			datos_tutor_empresa: "Datos del tutor en la empresa",
			tutor_nombre: "Nombre",
			tutor_apellidos: "Apellidos",
			tutor_cargo: "Cargo en Empresa",
			tutor_email: "E-mail",
			tutor_dni: "DNI",
			tutor_telefono: "Teléfono",

			horario: "Horario",
			num_horas_dia: "Número de horas al día",

			retribucion_euros_mes: "Retribución € brutos/mes",
			otras_remuneraciones: "Otras remuneraciones",
			descripcion_actividad: "Descripción detallada de la actividad a realizar por el alumno",
		},
		popup_aceptaSS: {
			info: "Información sobre la Seguridad Social",
			remunerada: "A partir del 1 de enero de 2024, tal y como establece el Real Decreto-Ley 2/2023 (artículo único ap.34). En el caso de <strong>las prácticas formativas remuneradas</strong>, el cumplimiento de las obligaciones de Seguridad Social corresponderá a la entidad u organismo que financie el programa de formación, que asumirá a estos efectos la condición de empresario.",
			no_remunerada: "A partir del 1 de enero de 2024, tal y como establece el Real Decreto-Ley 2/2023 (artículo único ap.34). En el caso de las prácticas formativas no remuneradas, el cumplimiento de las obligaciones de Seguridad Social corresponderá a la empresa, institución o entidad en la que se desarrollen aquellos, salvo que en el convenio o acuerdo de cooperación que, en su caso, se suscriba para su realización se disponga que tales obligaciones corresponderán al centro de formación responsable de la oferta formativa.<br><br> Si tenéis alguna duda o queréis hacernos algún comentario, por favor escribirnos un correo a la siguiente dirección: <a href='mailto:cmendoza@comillas.edu'>cmendoza@comillas.edu</a> con el Asunto: Convenio",
			entendido: "He leído y entiendo las obligaciones de Seguridad Social",
			aceptar: "Aceptar"
		}
	},
	en: {
		guardar: "Save",
		volver: "< Back",
		sin_definir: "Undefined",
		guardar_datos: "Save data",
		cancelar: "Cancel",
		confirmar: "Confirm",
		eliminar: "Delete",
		aceptar: "Accept",
		rechazar: "Reject",
		comenzar: "Get Started",
		cerrar_sesion: "Log Out",
		ver_menos: "Show less",
		ver_mas: "See more",
		inicio: "Home",
		ver_detalles: "View Details",
		editar: "Edit",
		anadir: "Add",
		enviar: "Send",
		requerido: "Required",
		revisar: "Review",
		editar_oferta: "Edit Offer",
		duplicar_oferta: "Double Bid",
		cerrar_oferta: "Close Deal",
		eliminar_oferta: "Eliminate offer",
		ver_como_candidato: "View as a candidate",
		practicas: "Internship",
		empleo: "Employment",
		ver: "View",
		selecciona_una_opcion: "Select an option",
		dropzone_texto_upload_mobile: "Click to attach the file",
		dropzone_texto_upload_desktop: "Drag or select the file to upload the document",
		escribe_para_filtrar: "Type to filter",
		no_hay_resultados: "No results",
		alert_error_generico: "ERROR",
		alert_proximamente: "Coming soon",
		alert_redireccion_recuperar: "Redirection to university/center systems so the user can recover their password",
		enlaces: {
			politica_privacidad: "/privacy-policy",
			politica_cookies: "/cookie-policy",
			login: "/login",
			solicitar_cuenta: "/request-account",
			registroalumno: "/registration",
			encuestas: "/surveys",
			encuesta: "/survey",
			eventos: "/events",
			eventospublico: "/public-event",
			documentacion: "/documentation",
			guiaOrientacion: "/guides-orientation",
			ofertas_practicas: "/internship-offers",
			ofertas_empleo: "/job-offers",
			cv: "/cv",
			vercv: "/ver-cv",
			mis_candidaturas: "/my-candidacies",
			mis_practicas: "/mis-practicas",
			orientacion: "/career-guidance",
			propuesta_practicas: "/proposal-practices",
			programapracticasactivos: "/active-internship-programs",
			solicitarcambiopracticas: "/request-change-internship",
			subirconvenio: "/up-agreement-signed",
			generarnuevoconvenio: "/new-agreement-collaboration",
			practicaseducacion: "/internship-applications",
			nueva_oferta: "/new-offer",
			editar_oferta: "/edit-offer",
			mi_empresa: "/my-company",
			mi_perfil: "/my-profile",
			mis_ofertas: "/my-offers",
			mi_oferta: "/offer",
			programa_practicas: "/internship-program",
			visualizar_oferta: "/visor-offer",
			restablecer_login: "/reset-login",
			restablecer_candidato: "/reset-candidate",
			setear_pass: "/set-login",
			proteccion_datos: "/data-protection",
			acceso_saml: "/access",
			logout: "/logout",
			ayuda: "/help",
			condicionespracticasuib: "/uib/practical-conditions",
			formulario_datos: "/form-data"
		},
		encabezado: {
			home: "Welcome@",
			cv: "My CV",
			cv_view: "Candidate's CV",
			eventos: "Events",
			propuesta_practicas: "Internship proposal",
			politica_privacidad: "Privacy Policy",
			politica_cookies: "Cookies policy",
			login: "Login",
			solicitar_cuenta: "New Company",
			registro_alumno: "Registration",
			ofertas_practicas: "List of internship offers",
			ofertas_empleo: "List of job offers",
			ficha_oferta_alumno_empleo: "List of job offers",
			ficha_oferta_alumno_practicas: "List of internship offers",
			mis_candidaturas: "My Applications",
			mis_practicas: "My internship",
			encuestas: "Surveys",
			orientacion: "Career guidance",
			nueva_oferta: "New offer",
			editar_oferta: "Edit Offer",
			mi_empresa: "My Company",
			mi_perfil: "My profile",
			documentacion: "Documentation",
			guiasOrientacion: "Orientation Guides",
			documentacion_empresa: "Documentation",
			documentacion_alumno: "My documentation",
			mis_ofertas: "My offers",
			mi_oferta: "My offer",
			ficha_oferta_empresa: "My offer",
			restablecer_login: "Reset Password",
			restablecer_candidato: "Reset Password",
			programapracticasactivos: "Active Internship Programs",
			setear_pass: "Set Password",
			proteccion_datos: "Data protection",
			visor_oferta: "View as a student",
			fichaProgramaActivo: "Active Programs",
			solicitudCambioPracticas: "Request for change of internship",
			solicitudesEducacion: "Applications for education offers",
			subirConvenioFirmado: "Upload signed agreement",
			generarNuevoConvenio: "New Collaboration Agreement",
			ayuda: "Help",
			condicionespracticasuib: "Practical conditions",
			info_alumno: "Please note that if you wish to undertake internships until August 31, you should not apply for the degree until after that date. If you apply for the degree before August 31, you will lose your student status and will no longer be able to undertake internships.",
			formulario_datos: "Data form",
			formulario_incorporacion: "Incorporation Form",
			falta_num_ss: "Due to the entry into force of the new RD, Royal Decree-Law 2/2023, of 16 March, which will come into force on 1 January 2024, is MANDATORY, you provide us with your Social Security number and attach a copy of it. Log in to your profile to fill in this information:"
		},
		ficha_oferta: {
			texto_programa_anadido: "You have this program added to your list of computer programs"
		},
		formulario: {
			nombre: "Name",
			nombre_apellidos: "Name and surname",
			apellidos: "Surnames",
			email: "Email",
			mensaje: "Message",
			fecha_nacimiento: "Date of birth",
			dia: "Day",
			mes: "Month",
			anyo: "Year",
			area_interes: "Area of your interest",
			trabaja_actualmente: "Are you currently working?",
			si: "Yes",
			no: "No",
			carta_presentacion: "Cover letter",
			meses: {
				Enero: "January",
				Febrero: "February",
				Marzo: "March",
				Abril: "April",
				Mayo: "May",
				Junio: "June",
				Julio: "July",
				Agosto: "August",
				Septiembre: "September",
				Octubre: "October",
				Noviembre: "November",
				Diciembre: "December"
			},
			archivo_adjunto: "Attach File",
			adjuntar_cv: "Attach CV",
			introduce_mail: "Enter your email",
			pais: "Country",
			telefono: "Phone",
			he_leido: "I have read and accept the",
			y_acepto: "Privacy Policy",
			enviar: "Send",
			enviado: "Sent"
		},
		meses: ["January", "February", "March", "April", "May", "June", "June", "August", "September", "October", "November", "December"],
		login: {
			iniciar_sesion: "Login",
			acceder: "Access",
			email: "Email",
			error_mail: "Please indicate your email address to log in to the portal.",
			contrasena: "Password",
			repetir_contrasena: "Repeat Password",
			contrasena_olvidada: "I forgot my password",
			introduce_email: "Enter your email",
			email_mal: "Email is malformed",
			recuperar_pass: "Recover my password",
			aun_no_registrado: "Not registered yet?",
			acceder_SSO: "ACCESS SSO UNIVERSITY",
			indica_mail: "Please enter your <strong>{{$t('offer.email')}}</strong> to log in to the portal.",
			selecciona_empresa: "Please select the company you want to log in with.",
			titulacion: "Qualification",
			tipo_formacion: "Type of academic background",
			selecciona_formacion: "Select a training type",
			registrarme: "Sign Up",
			deseo_recibir: "I would like to receive communications related to guidance and services related to higher education and the UIB.",
			popup_rgpd: {
				titulo: "MORE INFORMATION",
				detalle: "If you need more detailed information, you can access the Data Protection Policy at",
				enlace: "link.",
				boton: "I consent, access"
			},
			restablecer_pass: {
				titulo: "Follow the steps to reset your password",
				intro: "The password must contain at least 8 characters and a number.",
				guardar: "Save"
			},
			seteo_pass: {
				titulo: "Follow the steps to set your password",
				intro: "The password must contain at least 8 characters and a number.",
				guardar: "Save"
			}
		},
		registro: {
			encabezado: "Fill in the form below to register in the system:",
			datos_usuario: "Company User Data",
			datos_personales: "Personal data",
			nombre: "Name",
			apellidos: "Surnames",
			DNI: "Passport Number",
			CIF: "Company VAT number",
			puesto: "Position / Position",
			departamento: "Department",
			telefono_1: "Phone 1",
			telefono_2: "Phone 2",
			email: "Email",
			sede: "Default Headquarters",
			cargo: "Position",
			idioma: "Preferred language",
			tipo_contacto: "Contact Type",
			contrasena: "Password",
			repetir_contrasena: "Repeat Password",
			direccion: "Address",
			pais: "Country",
			selecciona_pais: "-Select a country-",
			selecciona_idioma: "-Select a language-",
			provincia: "Province",
			selecciona_provincia: "-Select a province-",
			localidad: "Location",
			selecciona_localidad: "-Select a location-",
			direccion_empresa: "Company Address",
			cp: "Zip Code",
			titulo_2: "Then enter your company details to register in the system:",
			anadir_imagen: "Click to add image",
			autorizar_logo: "Authorize use of the logo",
			nombre_fiscal: "Fiscal name or company name",
			nombre_comercial: "Trade Name",
			tipo_sociedad: "Type of society",
			selecciona_tipo_sociedad: "-Select type of company-",
			tipo_empresa: "Type of Company",
			privada: "Private",
			publica: "Public",
			startup: "Startup",
			eliminar: "Delete",
			descripcion: "Description",
			si: "Yes",
			no: "No",
			sector: "Sector",
			selecciona_sector: "-Select a sector-",
			otro_sector: "Other Sector",
			numero_empleados: "Number of employees",
			selecciona_empleados: "-Select a range-",
			web: "Web",
			iban: "IBAN account number",
			descripcion_empresa: "Company Description",
			femenino: "Female",
			masculino: "Male",
			telefono: "Phone",
			firmante: {
				titulo: "Please enter the details of the companys legal representative who will sign the agreements below:",
				nombre: "Signatory's Name",
				apellidos: "Signatory's Last Name",
				email: "Signatory Email",
				dni: "Signatory's ID card",
				cargo: "Signatory's Position",
				telefono: "Phone"
			},
			contacto: {
				nombre: "Contact Name",
				apellidos: "Contact Last Name",
				email: "Contact Email",
				telefono: "Phone"
			},
			envio_facturas: {
				titulo: "Address for sending invoices",
				titulo_2: "Billing Address"
			},
			anadir_direccion: "Add a new billing address",
			perfil_sectorial: "Sector profile",
			sector_actividad: "Sector of activity",
			selecciona_sector_actividad: "-Select a sector-",
			rango: "Billing range",
			selecciona_rango: "-Select a range-",
			selecciona_numero_empleados: "-Select a range-",
			anyo_fundacion: "Year Founded",
			politica_1: "I have read and accept the",
			politica_2: "Privacy Policy",
			nuevo_contacto_titulo: "Details of the new management contact",
			anadir_contacto: "Add contact",
			nueva_cuenta_fiscal: "New tax account data",
			domicilio_fiscal: "Tax Domicile",
			poblacion: "Location",
			requiere_envio_postal: "Requires postal delivery of invoices",
			domicilio_postal: "Address for postal delivery of invoices",
			anadir_cuenta: "Add Account",
			datos_firmante: "Signatory details",
			area_conocimiento: "Area or branch of knowledge",
			centro_lugar_estudios: "Study center or place",
			busca_centro_lugar: "Search the center or place",
			nombre_titulacion: "Name of the degree",
			ano_inicio: "Year of Inception",
			ano_finalizacion: "Year of completion",
			solicitar_cuenta: "Request Account",
			seguir_empresa: "Stick with company data",
			registrar_empresa: "Register Company",
			selecciona_sede: "-Choose one-",
			fiscal_empresa: "Tax Address",
			rgpd: {
				titulo: "Data Protection",
				responsable_tratamiento: "Data Controller",
				responsable_texto: "GENERAL FOUNDATION OF THE UNIVERSITY OF VALLADOLID (informacion@funge.uva.es). Data Protection Officer: dpo@funge.uva.es",
				finalidad_principal: "Main Purpose",
				finalidad_texto: "FUNGE's employment and career guidance activities develop actions aimed at facilitating the employability of students and university graduates, for which personal data is processed.",
				legitimacion: "Legal Basis",
				legitimacion_texto: "Contractual relationship. Data subject consent. Public interest.",
				categorias_datos_personales: "Categories of Personal Data",
				categorias_texto: "Identification data. Academic and professional data.",
				destinatarios: "Recipients",
				destinatario_1: "Companies participating in internship programs.",
				destinatario_2: "University of Valladolid",
				destinatario_3: "Entities responsible for selection on behalf of companies participating in internship programs.",
				derechos: "Rights",
				derechos_texto: "Access, rectify and delete data, as well as other rights, as explained in the additional information.",
				informacion_adicional: "Additional Information",
				informacion_adicional_texto_1: "You can find more information in the",
				informacion_adicional_texto_2: "and in our",
				registro_actividades: "Record of processing activities",
				politica_privacidad: "privacy policy"
			},
			dni_pasaporte_nie: "DNI/NIF/NIE/Passport",
			selecciona_nivel: "-Select a level-",
			busca_area: "Search the area",
			busca_titulacion: "Search for the degree",
			firmaDigital: "Type of signature for agreement",
			asume_coste_SS: "Does your institution agree to assume compliance with, management of, and payment of the Social Security obligations of students undertaking training placements or external academic internships at your institution, as set out in Royal Decree-Law 2/2023?",
			asume_coste_SS_Si: "Yes, we agree to assume the compliance, management and cost of the student's Social Security obligations, at the time it is effectively applied as set out in Royal Decree-Law 2/2023.",
			asume_coste_SS_No: "We do not accept. We request that the Comillas Pontifical University be the entity that assumes the compliance, management and cost of the student's Social Security obligations, at the time it is effectively applied as set out in Royal Decree-Law 2/2023."
		},
		idiomas:{
			es: "Spanish",
			en: "English"
		},
		propuesta_practicas: {
			intro: "If you have found a company where you can complete your curricular or extracurricular internships, you can register it here. We will evaluate and assign it if it meets all the required criteria.",
			documento_resumen: "Summary data collection document to complete the internship proposal in this form.",
			descargar: "Download",
			info_desconocido: "If you do not know any information, please indicate \"unknown\".",
			info_master: "If you are a Master's student in Secondary Education Teaching, Baccalaureate, Vocational Training and Language Teaching, you can request an educational center for your internships, whether you already have a confirmed place or not.",
			datos_academicos: "Academic data",
			paso_1_4: "Step 1 of 4",
			selecciona_titulacion: "Select a degree",
			placeholder_titulacion: "Click to select a degree",
			curso: "Course",
			tipo_practica: "What type of internship are you requesting/proposing?",
			curricular: "Curricular",
			extracurricular: "Extracurricular",
			solicitud_educacion: "Are you submitting a request for internships in an Education and Teaching degree?",
			plaza_confirmada: "Do you already have a confirmed place in a center?",
			plaza_si: "Yes, I have a confirmed place in an educational center",
			plaza_no: "No, I want to propose a center of my interest for the internship.",
			atencion: "Attention!",
			atencion_texto: "Only if you do not have your place confirmed for internships in an educational center.",
			solicitudes_restantes: "You have",
			solicitudes_centros_restantes: "center requests remaining.",
			certificado_centro_docente: "Educational center certificate",
			vida_laboral: "Employment history",
			datos_empresa: "Company data",
			paso_2_4: "Step 2 of 4",
			introduce_cif: "Enter the company VAT number where you will complete your internships.",
			cif_nif: "VAT (company) or Tax ID (self-employed)",
			validar_empresa: "Validate company",
			selecciona_centro: "Select the internship center. Search by province and name:",
			selecciona_centro_educativo: "Select the educational center:",
			centro_educativo: "Educational center",
			cargando: "Loading...",
			no_hay_empresas: "No companies found",
			no_encuentro_empresa: "I can't find the company",
			cif_empresa: "Company VAT number",
			datos_centro_trabajo: "Work center data",
			codigo_postal: "Postal code",
			dni_firmante: "Signatory ID",
			datos_contacto_empresa: "Company contact data",
			paso_3_4: "Step 3 of 4",
			introduce_email_contacto: "Enter your contact's email at the company.",
			validar_contacto: "Validate contact",
			puesto_cargo: "Role / Position",
			revisa_campos: "Please review all fields before continuing",
			aviso_confirmacion_universidad: "Attention! You have to wait for confirmation from the university for your internships to be validated. Your request will be processed and you will receive the resolution through campus messaging.",
			comprueba_datos_empresa: "Check that the company details match the company where you will carry out the internship. If you have any questions or there is an error, write to us at",
			nombre_empresa: "Company name",
			cif_no_existe: "The provided VAT number does not exist in our database, please fill in the following fields.",
			nombre_comercial: "Trade name",
			nombre_fiscal: "Legal name",
			email_empresa: "Company email",
			datos_representante_legal: "Now enter the details of the company's legal representative who will sign the agreements:",
			nombre_firmante: "Signatory name",
			apellidos_firmante: "Signatory surname",
			email_firmante: "Signatory email",
			telefono_firmante: "Signatory phone",
			cargo_firmante: "Signatory role",
			comprueba_datos_contacto: "Check that the company details match the contact details. If you have any questions or there is an error, write to us at",
			nombre_contacto: "Contact name",
			email_contacto: "Contact email",
			contacto_no_existe: "We do not have your contact details in our database, please fill in the details.",
			datos_firmante: "Signatory details",
			info_facturacion: "Additional billing information"
		},
		propuesta_practicas_empresa: {
			intro: "If a student is going to do internships in your company, you can register all details here. We will evaluate and formalize the proposal if both the offered internship and the selected candidate meet the required criteria.",
			datos_alumno: "Student data",
			instrucciones: "You can check the internship proposal instructions",
			selecciona_programa: "Select an internship program",
			introduce_dni: "Enter the candidate's ID number.",
			validar_candidato: "Validate candidate",
			titulacion_candidato: "Candidate degree",
			placeholder_titulacion_alumno: "Enter the student's degree",
			comprueba_datos_candidato: "Check that the candidate's details match. If you have any questions or there is an error, write to us at",
			nombre_candidato: "Candidate name"
		},
		programa_activo: {
			programa: "Program",
			duracion_practicas: "Internship duration",
			minima: "minimum",
			brutos_mes: "gross/month",
			tiempo_dedicacion: "Time dedicated to the internship",
			de: "of",
			jornada_laboral: "of the workday",
			nivel_estudios_permitidos: "Allowed study level",
			y: "and",
			informacion_general: "General information",
			objetivo: "Objective",
			requisitos: "Requirements",
			requisitos_candidatos: "Requirements for candidates",
			requisitos_empresas: "Requirements for companies",
			documentacion_necesaria: "Required documentation",
			documentacion_interes: "Documentation of interest",
			solicitud_adhesion_el: "Adhesion request on",
			empresa_ya_adherida: "Your company is already attached to this program",
			puede_adherirse_texto: "You can join the program by registering the internship offer linked to this program. The offer will then be reviewed and validated by the management team.",
			solicitar_adhesion: "Request adhesion",
			adherirme_programa: "Join the program",
			solicitud_inscripcion: "of registration request",
			proceso_seleccion: "Selection process",
			fecha_solicitud_inscripcion: "Registration request date",
			nota: "Grade",
			inscribete: "Sign up",
			acepto: "I accept"
		},
		home_empresa: {
			ofertas_practicas: "<strong>INTERNSHIP</strong> OFFERS",
			texto_ofertas_practicas: "View and manage internship offers and received applications.",
			nueva_practicas: "PUBLISH<strong>New internship offer",
			publicar_practicas: "Post internship opportunities, aimed at our students.",
			nueva_propuesta: "APPLY INTERNSHIP<strong>Internship proposal",
			publicar_propuesta: "If you don't want to address an offer to all our students but you already know the student who is going to do the internship. Submit your internship proposal for the student here.",
			ofertas_empleo: "<strong>JOB OFFERS",
			texto_ofertas_empleo: "View and manage job offers and received applications.",
			nueva_empleo: "POST<strong>New job offer",
			texto_nueva_empleo: "Post job openings."
		},
		mi_practica: {
			subir_documentacion: "Upload documentation",
			descargar_anexo: "Download Signed Annex",
			descargar_certificado: "Download internship certificate",
			descargar_poliza: "Download insurance policy",
			info_poliza: "Information about your insurance policy",
			titulo_practicas: "To be able to take part in these internships, the following is required:",
			pagar_creditos: "Pay the credits that are going to be recognized.",
			descarga: "Download",
			aqui: "here",
			documento_pago: "the Payment Letter document with the information of amounts due and instructions.",
			contratar_poliza: "Take out an accident policy that covers these practices",
			puedes_contratar: "You can take out any insurance policy, if you wish you can take out it online",
			mensaje_documentos: "Once you have the documents <strong>ready</strong>, please <strong>scan them and attach them</strong> below. We will check that they are valid before signing the contract with the company.",
			digitaliza_documentos: "Once you have the document <strong>ready</strong>, please <strong>scan it and attach it</strong> below. We will check that it is valid before signing the contract with the company.",
			adjuntar_pago: "Attach payment receipt",
			adjuntar_seguro: "Attach insurance policy",
			descarga_ficheros: "Download the following files, sign them and attach them again.",
			enviar: "Send",
			renuncia_practicas_SET: "These extracurricular internships will be part of your SET (European Diploma Supplement) if you meet the legal requirements, in case you do not want them to join SET, you must attach a signed resignation document. You can download the document template",
			adjuntar_renuncia: "Attach signed waiver"
		},
		mis_practicas: {
			titulo: "In this section you will find all the documentation regarding your internship.",
			zero_1: "There is no internship or internship documentation to show. If in doubt, please contact:",
			gracias: "Thank you very much.",
			emailJuridica: "practicas.derecho@comillas.edu",
			emailIngenieria: "practicas.ingenieria@comillas.edu",
			emailEconomica: "practicas.ade.ibs@comillas.edu",
			emailSanitaria: "practicas.soci.sani@comillas.edu",
			emailEducacion: "mvtorres@comillas.edu",
			emailRRII: "practicas.ri.com.ti@comillas.edu",
			emailInternacional: "jrmunoz@comillas.edu"
		},
		cambio_password: {
			titulo: "Change password",
			titulo_candidato: "Want to change your password?",
			contrasena_actual: "Current password",
			nueva_contrasena: "New Password",
			repetir_contrasena: "Repeat New Password"
		},
		guia_orientacion: {
			titulo: "Below you will find documents related to your internships or employment, as well as advice and best practices that may be of interest to you.",
			zero: "No orientation guides"
		},
		mi_empresa: {
			intro: {
				cuerpo: "Below are the main facts about your company. If any of them are incorrect, or you need to access, correct, delete any details of your information.",
				porfavor: "If you have any questions, please ",
				contacte: "contact us."
			},
			datos_empresa: "Company Data"
		},
		formulario_datos: {
			intro: {
				cuerpo: "Below are the main facts about your company. Update or fill in the following information about your company.",
				porfavor: "Please,",
				contacte: "Contact us."
			},
			datos_empresa: "Company Data",
			datos_firmante: "Signatory details",
			datos_contacto: "Contact details"
		},
		candidaturas_options: {
			aceptar: "Accept Enrollment",
			rechazar: "Decline Enrollment",
			motivos_rechazo: "Reasons for rejection",
			selecciona_motivo: "- Select a rejection reason -",
			rechazar_preinscripcion: "Decline pre-enrolment"
		},
		oferta: {
			intro_editor: "Fill out the form below to create a new offer:",
			tipo_oferta: "Offer Type",
			numero_plazas: "Number of places",
			experiencia: "Experience",
			experiencia_deseable: "Desirable experience",
			horario: "Schedule",
			fecha_inicio: "Start Date",
			fecha_fin: "End date",
			tipo_contrato: "Type of contract",
			salario: "Salary",
			creditos: "Credits exceeded",
			otras_remuneraciones: "Other remuneration",
			pais: "Country",
			poblacion: "Location/Province",
			poblacion_only: "Location",
			provincia: "Province",
			sector: "Sector",
			area_funcional: "Functional Area",
			sede: "Headquarters/Campus",
			beca: "Monthly Scholarship",
			descripcion_puesto: "Job Description",
			tarea: "Task",
			tutores_disponibles: "Available tutors",
			otras_tareas: "Other tasks",
			programa_practicas: "Internship program",
			aviso_programa: "please check the mandatory requirements",
			aviso_requisitos_programa: "Do not forget to review this program's requirements for internship offers. You can check all details",
			aqui: "here",
			escribe_para_buscar: "Type to search",
			ocultar: "Hide",
			selecciona_tutor: "Select a tutor",
			enlace_inscripcion: "Registration Link",
			ir_enlace: "Go to link",
			idiomas: "Languages",
			anadir_idiomas: "Add Languages",
			empleo: "Employment",
			practicas: "Internship",
			certificacion: "- Minimum certification required:",
			requerido: "- Required",
			estudios_obligatorios: "Compulsory studies",
			estudios_deseables: "Desirable studies",
			estudios_propuestos: "Proposed studies",
			requisitos_obligatorios: "Mandatory requirements",
			etiquetas: "Tags",
			otros_obligatorios: "Other Mandatory",
			edad_maxima: "Maximum age",
			salario_maximo: "Maximum Salary",
			intereses_deseables: "Desirable interests",
			intereses_obligatorios: "Mandatory interest",
			intereses_seleccionados: "Selected interests",
			competencias_obligatorias: "Mandatory competencies",
			competencias_seleccionadas: "Selected competencies",
			paises_nacionalidad_obigatorios: "Countries of Nationality required",
			paises_residencia_obligatorios: "Mandatory Countries of Residence",
			provincia_residencia_obligatorios: "Province of Residence Mandatory",
			paises_seleccionados: "Selected countries",
			provincias_seleccionados: "Selected provinces",
			coche_propio: "Own car",
			obligatorio_quest: "Mandatory?",
			carnet_conducir: "Driver's license",
			disponible_extranjero: "Available to work abroad",
			disponible_residencia: "Available for change of residence",
			trabajando_actualmente: "Working Currently",
			requisitos_deseables: "Desirable requirements",
			otros_requisitos_deseables: "Other Desirable Requirements",
			otros_requisitos_obligatorios: "Other mandatory requirements",
			motivos_exclusion: "Reasons for exclusion",
			competencias_deseables: "Desirable competencies",
			paises_nacionalidad_deseables: "Desirable Nationality Countries",
			paises_residencia_deseables: "Desirable Countries of Residence",
			provincia_residencia_deseables: "Desirable Province of Residence",
			programas_informaticos: "Software",
			programas_informaticos_deseables: "Desirable software",
			documentos_requeridos: "Required Documents",
			documentos: "Documents",
			marca_documentos: "Mark the documents that candidates must provide.",
			anadir_otro_documento: "Add another document type",
			nombre_documento_candidato: "Name of the document to be provided by the candidate",
			inscribirme: "Sign Up",
			desinscribirme: "Unsubscribe",
			ya_inscrito: "You are already registered",
			cancelar_inscripcion: "Unenroll",
			buscar_mas_intereses: "Find more interests",
			atencion: "Attention!",
			tramitar_inscripcion: "To complete your registration for this offer, you must submit your application on the offering companys website.",
			acceder: "To access",
			pincha_aqui: "Click here.",
			especialidad: "Specialty",
			estado: "Status",
			datos_practica: "Practice data",
			paso_4: "Step 4 of 4",
			tareas_a_desarrollar: "Tasks to be carried out",
			horario_practicas: "Internship schedule",
			horario_trabajo: "Working hours",
			tengo_candidato: "I have a candidate",
			horas_dia: "Hours per day",
			remuneracion: "Remuneration(€ gross/month)",
			otros_beneficios: "Other benefits",
			fecha_alta: "Date Added",
			duracion_meses: "Duration (in months)",
			dedicacion: "Dedication (% of working hours)",
			departamento: "Department",
			modalidad: "Modality",
			numero_dias_semana: "Number of days per week",
			dias_semana: "Days of the week",
			vinculado_tfg: "Linked to TFG",
			nombre_tfg: "Name TFG",
			tutor_tfg: "TFG Tutor",
			solicitante: "Service Requester",
			centro_practicas: "Internship Center",
			n_pedido: "Order number (if required)",
			observaciones: "Observations",
			direccion: "Address",
			nombre_tutor_uni: "Name and surname of the University tutor",
			datos_tutor_empresa: "Details of the tutor in the company",
			nombre: "Name",
			apellidos: "Surnames",
			email: "Email",
			telefono: "Phone",
			cargo: "Position",
			dni: "DNI",
			titulacion_especialidad: "Qualification or speciality",
			titulacion: "Qualifications/Position",
			selecciona: "-Select-",
			nombre_oferta: "Offer Name",
			experiencia_requerida: "Experience Required",
			opciones_publicacion: "Publishing options",
			url_inscripcion: "Company registration URL",
			candidato_preferido: "Preferred Candidate",
			datos_realizacion: "Internship data",
			conocimientos_especificos: "Specific knowledge",
			formacion_adquirida: "Acquired training",
			seguimiento_previsto: "Planned follow-up",
			empresa_destino: "Destination company (only if it is an offer from a temporary employment agency manager/consultant)",
			datos_tutor: "Company tutor details",
			para_estudiantes_ultimo_ano: "Last year students​",
			curso_minimo_requerido: "Minimum course required",
			para_perfil_no_universitario: "For non-university profile",
			activo_quest: "Active?",
			ano_promo_maximo: "Maximum Promotion Year",
			enviar_quest: "Send?",
			candidato_leer: "Candidate to read",
			candidatos_leer: "Candidates to read",
			candidato_total: "Total candidate",
			referencia: "Reference",
			candidatos_total: "Total candidates",
			ver_detalles: "View Details",
			con_practicas: "- With assigned practices",
			fecha_caducidad: "Expiration Date",
			buscar_mas_programa: "Find more software",
			programas_elegidos: "Selected software",
			sin_programas: "No specified software",
			selecciona_idioma: "Select a language",
			escribe_idioma: "Enter the language here",
			indica_certificacion: "Please indicate the required certification or minimum level here",
			titulaciones: "Qualifications",
			requeridas: "required",
			deseables: "Valuable",
			propuestas: "Proposals",
			a_las_que: "to which the offer is directed",
			nivel: "Level",
			areas: "Areas",
			cualquier_area: "Any area",
			ninguna_titulacion: "No degree",
			eliminar_todas: "Delete all",
			areas_dirige: "Areas targeted by the offer",
			titulaciones_dirige: "Degrees to which the offer is aimed",
			selecciona_titulaciones: "Select the degrees in the list on the left",
			cumplimentar: "Fill in only relevant information for the candidates, if you consider it relevant.",
			tipo_estudios: "Type of studies",
			seleccione_izquierda: "Select the areas in the list on the left.",
			seleccione_algun_nivel: "Select a level to load the associated areas",
			especialidad_titulacion: "Speciality or qualification(s)",
			puesto_trabajo: "Workstation",
			motivo_rechazo: "Reason for rejection",
			ayuda_estudio: "Study Aid",
			tutor_empresa: "Company Tutor",
			nombre_tutor: "Name of the company tutor",
			apellidos_tutor: "Tutor's surname company",
			email_tutor: "Company tutor email",
			telefono_tutor: "Company tutor's telephone number",
			cargo_tutor: "Position of the company tutor",
			titulacion_tutor: "Qualification of the company tutor",
			departamento_tutor: "Company tutor department",
			dni_tutor: "ID card of the company tutor",
			no_definido: "Not defined",
			candidatos: "Candidates",
			exportar: "Export",
			no_hay_candidatos: "There are no candidates in this offer",
			mas: "more",
			menos: "less",
			empresa_destino_simple: "Destination Company",
			tipo_formacion: "Type of training",
			niveles: "Levels",
			para_estudiantes_ultimo_curso: "For final year students",
			duplicar_oferta_aviso: "Bid duplicated correctly Want to edit it now?",
			alumno_validado_uib: "Student validated by DOIP UIB",
			condicionespracticas: "I have read and agree to the conditions. <a target='_blank' href='/uib/practical-conditions'>See conditions</a>",
			idioma: "Language",
			ofertacerrada: "A closed offer will not be visible or receive new candidates. Are you sure you want to close this offer?",
			eliminaroferta: "The offer Want to continue?",
			ofertaduplicada: "Offer successfully duplicated. Would you like to edit it now?",
			controlCerraroferta: "Have you selected any of the candidates proposed by DOIP UIB?",
			cumplimentainformacion: "Please fill in the following information:",
			nombrepersona: "Name and surname of the selected person",
			fechainiciocontrato: "Contract start date",
			tipocontrato: "Type of contract",
			nota_media: "Average grade",
			nombre_apellidos_dni: "Name, surname and ID",
			ocultar_datos_empresa: "Hide company data",
			url_informacion_complementaria: "URL for additional information",
			fichero_informacion_complementaria: "Additional information file:",
			seleccionar_archivo: "Choose file",
			ningun_archivo: "No file has been selected",
			ver_fichero_adjunto: "See attached file:",
			ver_fichero: "See file",
			datos_firmante: "Signatory details",
			selecciona_una:"Select one",
			firmante: {
				nombre: "Signatory's Name",
				apellidos: "Signatory's Last Name",
				email: "Signatory Email",
				dni: "Signatory's ID card",
				cargo: "Signatory's Position",
				telefono: "Phone"
			}
		},
		filtro_oferta: {
			buscar_nombre: "Search by job title",
			buscar_localizacion: "Search by location",
			buscar_titulacion: "Search by degree",
			buscar_puesto: "Search by job title",
			filtro_avanzado: "Advanced Filter",
			cerrar: "Close",
			fecha_publicacion: "Publication date",
			fecha_inicio_previsa: "Planned practice start date",
			fecha_inicio: "Start Date",
			filtrado_etiqueta: "Filtering by tags",
			omitir_inscritos: "Skip already enrolled",
			becas_colaboracion: "Collaboration grants",
			oferta_tfg: "TFG/TFM Offer",
			ofertas_internacional: "International offer",
			ofertas_cv: "Offers that fit my profile/CV",
			busquedas_guardadas: "Saved Searches",
			guardar_busqueda: "Save Search",
			borrar_filtros: "CLEAR FILTERS",
			descargar_candidatos: "Download all candidates",
			ver: "View",
			fecha: "Date",
			ofertas_tfg: "TFG/TFM Offer",
			se_han_encontrado: "They have been found",
			introduce_nombre_busqueda: "Enter the name of the search",
			sobreescribe_existente: "or overwrites an existing one",
			selecciona_busqueda: "Select a search",
			ver_historico: "See offer history",
			ver_actuales: "View Current Offers",
			crear_oferta: "CREATE OFFER",
			historico_ofertas: "Offer history",
			no_hay_ofertas: "No offers matching your search",
			solo_con_candidatos: "Only offers with unread candidates",
			tienen_candidatos: "They have candidates",
			caduca_pronto: "They expire soon",
			no_leidos: "Only unread",
			modalidad: "Modality",
			puesto_Empresa: "Position/ Company",
			buscar_sector: "Search by industry",
			estados: { "1": "Pending", "2": "Published", "3": "Managed", "4": "Company closed", "5": "Closed awarded", "6": "Closed without awarding", "7": "Not publishable", "8": "Reservation" },
			idPerfil: { "1": "Employment", "2": "Internship" }
		},
		popup_confirmacion: {
			recuerda: "Remember!",
			titulo: "Make sure your profile details are up to date before signing up for an offer.",
			actualiza: "Update it by clicking",
			aqui: "here.",
			confirma_titulo: "Please confirm that you want to be a candidate in this offer.",
			atencion: "Attention!",
			necesitamos_anadir: "We need you to add the following documents in order to register for the offer.",
			url_documento: "Document URL",
			por_favor_adjunta: "Please attach a file or url",
			alumnos_master: "Students in two-year masters programmes must have completed at least 50% of the credits to do an internship. Are you enrolled in a masters programme of less than two years, or have you completed more than 50% of the credits?",
			inscripcion_externa: "Registration for this offer is done through the company's website.",
			confirma_inscripcion_externa: "Please confirm that you want to be redirected to the company's website to to apply to the position"
		},
		header: {
			hola: "Hello,",
			oferta_practicas: "Search internship offers",
			oferta_empleo: "Search for job openings",
			propuesta_practicas: "Internship proposal",
			candidaturas: "My Applications",
			practicas: "My internship",
			programas: "Programs",
			encuestas: "Surveys",
			eventos: "Events",
			mi_cv: "My CV",
			guias_orientacion: "Orientation Guides",
			mis_ofertas: "My offers",
			nueva_oferta: "New offer",
			solicitar_cambio_practicas: "Request Change of Internship",
			documentacion: "Documentation",
			solicitudes_practicas_educacion: "Practical applications education",
			mi_empresa: "My Company",
			ayuda: "Help",
			cerrar_sesion: "Log Out",
			solicitar_baja: "Request Cancellation",
			formulario_datos: "Data form",
			asesoramiento: "Request Advice"
		},
		image_uploader: {
			titulo: "Edit profile picture"
		},
		notificaciones: {
			borrar_todo: "Clear All",
			importantes: "Important",
			otras_notificaciones: "Other notifications",
			no_notificaciones: "You don't have any pending notifications"
		},
		popup_borrar_cuenta: {
			titulo: "Do you want to request the cancellation of the service and the deletion of your personal data?",
			si: "Yes",
			no: "No"
		},
		popup_faltan_datos_empresa: {
			atencion: "Attention!",
			cuerpo_1: "Mandatory data is missing from your profile, please log in to complete them.",
			cuerpo_2: "Mandatory data is missing from your company profile, please log in to complete them.",
			ir_a_perfil: "Go to my Profile",
			ir_a_empresa: "Go to My Company"
		},
		popup_datos_personales: {
			atencion: "Attention!",
			titulo: "Mandatory data is missing from your profile, please log in to complete them.",
			ir_a_perfil: "Go to my Profile"
		},
		solicitudes_educacion: {
			titulo: "In this section you will find information on students who have applied for internships at their institution.",
			zero: "There is no documentation at this time."
		},
		filtro_candidaturas: {
			buscar_nombre: "Search by job title",
			empleo: "Employment",
			practicas: "Internship",
			filtro_avanzado: "Advanced Filter",
			cerrar: "Close",
			estado: "Status",
			ver: "View",
			borrar_filtros: "CLEAR FILTERS",
			estas_en: "You are in",
			zero: "There are no selection processes matching your search"
		},
		documentacion: {
			adjunto: "Attached",
			intro: "In this section you will find the documentation related to the internships that have been carried out in your company.",
			convenio_titulo: "Educational cooperation agreements",
			caducado: "Expired",
			zero_convenio: "You don't have an agreement yet",
			titulo_convenio: "If you wish, you can request and download the collaboration agreement, or provide the document already signed by your company:",
			nuevo_convenio: "New agreement",
			subir_convenio: "Upload signed agreement",
			anexos_practicas: "Internship Annexes",
			zero_practicas: "You don't have content yet",
			notas_formativas: "Training notes",
			en: "in",
			otros_documentos: "Other documents associated with internships",
			zero_documentos: "You don't have an internship document yet",
			otros_documentos_programas: "Other documents associated with programs",
			zero_documentos_practicas: "You don't have any documents associated with programs yet",
			documentos_aportados_empresa: "Other documents provided by the company",
			no_documentos_anadidos: "No documents added, tap Add Document to add it",
			anadir_documentacion: "Add documentation",
			selecciona_documento: "Select a document",
			listado_documento: "List of documents",
			otro_tipo_documento: "Other document type",
			nombre_documento: "Document Name",
			url_documento: "Document URL",
			adendas: "Addenda/Other Documents:",
			activo: "Active",
			subir_convenio_intro: "Attach here the Educational Cooperation Agreement file signed by your company to process the signature.",
			convenios_pendientes: "Pending agreements",
			selecciona_convenio: "Select the agreement",
			no_convenios_para_subir: "You do not have generated agreements yet where you can attach the signed file.",
			subir_convenio_boton: "Upload agreement"
			,
			tooltip_nuevo_convenio: "Request the generation of a new collaboration agreement.",
			tooltip_subir_convenio: "To send agreements already generated and signed by your company."
		},
		encuestas: {
			titulo: "Pending Surveys",
			obligatorias: "To continue, answer all the required questions",
			enviar: "Send",
			siguiente: "Next",
			empezar_de_nuevo: "Start over",
			pagina: "Page",
			datos_enviados: "Your data has been sent",
			muchas_gracias: "Thank you very much!",
			iniciar_sesion: "Sign in with your profile username",
			empresa: "Company",
			candidato: "Candidate",
			usuario: "User",
			contrasena: "Password",
			acceder: "Access",
			o: "ó",
			acceder_anonimamente: "Log in anonymously",
			contestar_pregunta: "You must answer this question to continue",
			zero: "No surveys available",
			cuerpo: "Please, before continuing, take these surveys",
			no_puedes: "You can't access the portal until you've completed any pending surveys. If you don't want to respond at this time, you can log out."
		},
		eventos: {
			proximos: "Upcoming Events",
			pasados: "Past events",
			evento_destacado: "Featured event",
			desde: "From",
			hasta: "Up to",
			organizado_por: "Organized by",
			inscribirse: "Sign Up",
			inscrito: "Enrolled",
			mas_informacion: "Learn more",
			galeria: "Image Gallery",
			videos: "Videos",
			buscar_localizacion: "Search by location",
			buscar_categoria: "Browse by Category",
			buscar_nombre: "Search by name",
			eventos_pasados: "Past events",
			ver_mas: "See more"
		},
		comunicaciones: {
			titulo: "Communications"
		},
		guias: {
			titulo: "Latest Guidance Guides",
			zero: "No orientation guides"
		},
		ofertas: {
			ultimas_practicas: "Latest Internship Offers",
			practicas: "Internship",
			ultimas_empleo: "Latest Job Offers",
			empleo: "Employment",
			ofertas: "Offers",
			zero_ofertas: "No offers available.",
			contrato: "Contract",
			idContrato: "Contract",
			salario: "Salary",
			areaFuncional: "Functional Area",
			provincia: "Province",
			areasTitulaciones: "Areas of degrees",
			nivelesTitulaciones: "Degree levels",
			tiposFormacion: "Types of training",
			tituloPrograma: "Program",
			area: "Area",
			filtrar_titulacion: "Filter by Degree",
			tipoModalidadAsistencia: "Modality of assistance"
		},
		cv: {
			nivel: "Level",
			programa_informatico: "Software",
			certificado: "Certificate",
			sin_nivel: "No defined level",
			presentacion: "Presentation",
			anadir_presentacion: "To add your presentation click",
			aqui: "here",
			otros_intereses: "Other interests",
			tus_interes: "Your interests",
			sin_intereses: "No interest specified",
			escribe_interes: "Type in some interest, to start searching",
			click_interes: "Click on the interest to add it",
			click_cambiar_imagen: "Click to change image",
			cambiar_contrasena: "Change password",
			idiomas: "Languages",
			idioma: "Language",
			sin_idiomas: "No languages added, tap Add language to add it",
			idioma_obligatorio: "Language and level are required fields to add a language",
			nivel_no_definido: "Level not defined",
			nombre_certificado: "Certificate Name",
			estancia_extranjero: "Stay abroad",
			pais_estancia: "Country of stay",
			motivo_estancia: "Reason for stay",
			duracion_meses: "Duration in months",
			experiencia_profesional: "Professional experience",
			anadir_nueva_experiencia: "Add new experience",
			sin_experiencia: "No experience",
			nivel_formativo: "Training level",
			actualidad: "Present",
			puesto: "Job Title",
			anadir_documento: "Add Document",
			sector_empresa: "Company Sector",
			area_actividad_puesto: "Position area of activity",
			tipo_contrato: "Type of contract",
			subtipo_contrato: "Contract subtype",
			ver_adjunto: "See attachment",
			ver_enlace: "See link",
			duracion: "Duration",
			fecha_inicio: "Start Date",
			fecha_fin: "End date",
			provincia: "Province",
			empresa: "Company",
			enlace: "Link",
			descripcion_puesto: "Job Description",
			escribe_descripcion: "Write a description of the tasks performed",
			anadir_fichero: "Add Attachment",
			adjunto_correctamente: "Attachment correctly",
			isla: "Island",
			programas_informaticos: {
				titulo: "Software",
				buscar: "Type to search",
				zero: "No software added, tap add to add",
				anadir: "Add Program"
			},
			sectores_interes: {
				titulo: "Sectors of interest",
				buscar: "Type to search",
				zero: "No sectors of interest added, click on add to add them",
				anadir: "Add sector of interest"
			},
			documentacion_adjunta: "Attached documentation",
			documentacion_subida: "Documentation uploaded on",
			no_hay_documentos: "No documents added",
			pulsa_anadir_documentos: ", tap Add document to add it",
			anadir_documentacion: "Add documentation",
			selecciona_documento: "Select a document",
			listado_documento: "List of documents",
			otro_tipo_documento: "Other document type",
			nombre_documento: "Document Name",
			url_documento: "Document URL",
			documentacion_privada: "Private documentation",
			no_documentos: "No documents added, tap Add Document to add it",
			documentacion_ligada: "Process-related documentation",
			datos_profesionales: "Professional data",
			visitar: "Visit",
			indica_link_perfil: "Provide a link to your profile",
			trabajando_actualmente: "Working Currently",
			permiso_trabajo: "EU work permit",
			anos_experiencia: "Years of experience",
			disfrutado_erasmus: "I have been on Erasmus or I have enjoyed another mobility grant",
			minima_retribucion: "Minimum remuneration",
			brutos_anuales: "/ annual gross",
			datos_personales: "Personal data",
			dni: "DNI",
			fecha_nacimiento: "Date of birth",
			genero: "Gender",
			femenino: "Female",
			masculino: "Male",
			email_personal: "Personal Email",
			email_estudiante: "Student Email",
			avisos_en_email: "Personal Email Notifications",
			acepta_newsletter: "Accept newsletter",
			idioma_comunicaciones: "Preferred language for communications",
			movil: "Mobile",
			fijo: "Landline",
			direccion_empadronamiento: "Registration address",
			direccion_actual: "Current Address",
			direccion: "Address",
			iban: "IBAN account number",
			seguridad_social: "Social Security No.",
			pais_nacionalidad: "Country of nationality",
			pais_segunda_nacionalidad: "Second nationality country",
			provincia_nacimiento: "Province of birth",
			lugar_nacimiento: "Place of Birth",
			discapacidad: "Disability greater than 33%",
			deseo_recibir_comunicaciones: "I would like to receive communications related to guidance and services related to higher education and the UIB:",
			nombre: "Name",
			primer_apellido: "First surname",
			segundo_apellido: "Second surname",
			tipo_identificacion: "Type of ID",
			documento_identidad: "Identity document",
			buscar: "Type to search",
			cp: "Zip Code",
			pais: "Country",
			localidad: "Location",
			tipo_via: "Type of road",
			numero: "Number",
			piso: "Floor",
			puerta: "Door",
			notas: "Notes",
			datos_academicos: "Academic data",
			formacion_complementaria: "Complementary training",
			anadir_titulacion: "Add new degree",
			complementaria: "complementary",
			centro: "Center",
			nivel_academico: "Academic level",
			tipo: "Type",
			nota: "Note",
			rama_ensenanza: "Branch of teaching",
			actual: "Current",
			si: "Yes",
			no: "No",
			titulo: "Title",
			universidad: "University/Place of Study",
			calificacion: "Rating",
			calificacion_media: "Average degree rating",
			horas: "Hours",
			ambito: "Teaching",
			selecciona_tipo: "- Select a type -",
			certificacion: "Certification",
			tienes_cerfificacion: "Do you have certification?",
			competencias_profesionales: "Professional skills",
			tus_competencias: "Your skills",
			sin_competencias: "No specified professional competencies",
			solicitar_sesion: "Do you need help filling out this section? You can request a free orientation session with us by clicking on this <a href='https://content.fueib.org/es/orientacion?hsCtaTracking=b23fd2f4-3b24-4c45-9d90-9fd88b353e09%7Cd6de5ac5-da0e-420e-a24c-dc6ecd1b9dba' target='_blank'>link</a> and we will help you.",
			datos_interes: "Interesting facts",
			busqueda_activa_practicas: "Active search for internships",
			busqueda_activa_empleo: "Active job search",
			disponible_extranjero: "Available to work abroad",
			permiso_conducir: "Driving licence",
			disponible_cambio_residencia: "Available for change of residence",
			coche_propio: "Own car",
			disponible_viajar: "Available for travel",
			discapacidad_certificada: "Certified Disability",
			carnet_moto: "Motorcycle license",
			moto_propia: "Own motorcycle",
			disponibilidad_jornadas: "Availability of working days",
			periodo_preferencia_practicas: "Internship preference period",
			selecciona: "Select",
			anadir_idioma: "Add Language",
			anadir_intereses: "Add Interest",
			nuevos_datos_academicos: "New academic data",
			ocultar_de_mi_perfil: "Hide from my profile",
			centro_estudios_placeholder: "Center where you completed your studies",
			duracion_horas: "Duration in hours"
		},
		addtitulacion: {
			titulo: "Degrees to which the offer is aimed",
			seleccione_areas: "Select area(s) to filter degrees",
			borrar_areas: "Clear all areas",
			cualquier_area: "Any area",
			escriba_aqui: "Type here to filter the list of degrees below",
			selecciona_titulacion: "Select the degree(s) to which the offer is addressed by clicking on it",
			ver_titulaciones: "See bachelor's degrees",
			listadas: "Listings",
			listados: "Listings",
			cualquier_titulacion: "Any of these bachelor's degrees",
			ver_titulaciones_postgrado: "See postgraduate degrees",
			cualquier_titulacion_postgrado: "Any of these postgraduate degrees",
			ver_titulaciones_propio: "See Bachelor's Degree Degrees",
			cualquier_titulacion_propio: "Any of these own degrees",
			lo_sentimos: "Sorry, no titles found matching the search",
			listado_titulaciones_seleccionadas: "List of selected degrees",
			eliminar_titulaciones: "Delete all selected degrees"
		},
		candidato: {
			nuevo: "New",
			cambiar_estado: "Change status",
			ver_cv: "View CV",
			detalles: "Candidate details",
			selecciona_estado: "Select a state",
			seleccione_motivo: "Please select the candidate's reason for rejecting.",
			cambio_estado: "Change of status",
			descargar_cv: "Download CV",
			cumplimentar_formulario_incorporacion: "Fill out the Incorporation Form",
			expediente: "Record",
			info_formulario_practicas: "Please complete the form below with the internship details this candidate will carry out in your company.",
			dotacion_mensual: "Monthly allowance",
			descripcion_contenido_formativo: "Training content description",
			informacion_adicional_facturacion: "Additional billing information"
		},
		cambio_practicas: {
			identifica: "Identify the student from whom they are requesting an extension or variation of their internship conditions.",
			alumno: "Student",
			selecciona_oferta: "Select the offer",
			no_practicas: "You don't have any practices yet that you can request a change to.",
			selecciona_alumno: "Select the student",
			detalles: "Modification Details",
			tipo_modificacion: "Modification Type",
			selecciona_modificacion: "-Select the modification-",
			otros_detalles: "Other details",
			adjunto: "Attachment",
			solicitar_cambio: "Request Change"
		},
		popup_idioma: {
			titulo: "You're going to change your language preference. Want to continue?"
		},
		formulario_incorporacion: {
			formularioYaCumplimentado: "This incorporation form has already been completed and the student has been selected.",
			encabezado: "Fill out the onboarding form to complete the student's application and make it selected.",
			persona_de_contacto: "Contact Person",
			contacto_nombre: "Name",
			contacto_apellidos: "Surnames",
			contacto_cargo_departamento: "Position/Department",
			contacto_email: "E-mail",
			contacto_num_telefono: "Phone number",
			persona_firmante_anexo_convenio: "Signatory of the Annex",
			persona_firmante_convenio_empresa: "Signatory of the company agreement",
			firmante_nombre: "Name",
			firmante_apellidos: "Surnames",
			firmante_cargo_departamento: "Signatory's Position",
			firmante_email: "E-mail",
			firmante_telefono: "Phone",
			datos_alumno: "Student Data",
			alumno_dni: "DNI",
			alumno_nombre_apellidos: "Name and surname",
			alumno_titulacion: "Qualification",
			fecha_inicio: "Start Date",
			fecha_fin: "End date",
			datos_periodo_practicas: "Facts about the Internship Period",
			lugar_realizacion_practicas: "Place of the internship",
			datos_tutor_empresa: "Details of the tutor in the company",
			tutor_nombre: "Name",
			tutor_apellidos: "Surnames",
			tutor_cargo: "Position in Company",
			tutor_email: "E-mail",
			tutor_dni: "DNI",
			tutor_telefono: "Phone",
			horario: "Opening hours",
			num_horas_dia: "Number of hours per day",
			retribucion_euros_mes: "Remuneration € gross/month",
			otras_remuneraciones: "Other remuneration",
			descripcion_actividad: "Detailed description of the activity to be carried out by the student"
		},
		popup_aceptaSS: {
			info: "Social Security Information",
			remunerada: "From 1 January 2024, as established in Royal Decree-Law 2/2023 (sole article ap.34). In the case of <strong>paid training internships</strong>, compliance with Social Security obligations will correspond to the entity or body that finances the training programme, which will assume the status of employer for this purpose.",
			no_remunerada: "From 1 January 2024, as established in Royal Decree-Law 2/2023 (sole article ap.34). In the case of unpaid training internships, compliance with Social Security obligations will correspond to the company, institution or entity in which they are carried out, unless the cooperation agreement or cooperation agreement that, where appropriate, is signed for their performance provides that such obligations will correspond to the training centre responsible for the training offer. <br><br> If you have any questions or would like to make any comments, please write us an email to the following address: <a href='mailto:cmendoza@comillas.edu'>cmendoza@comillas.edu</a> with the Subject: Agreement",
			entendido: "I have read and understand the Social Security obligations",
			aceptar: "Accept"
		}
	},
}



// WEBPACK FOOTER //
// ./src/translations/index.js